msgid ""
msgstr ""
"POT-Creation-Date: 2025-01-07 14:43+0300\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: ru\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. js-lingui-explicit-id
#: src/utils/validation.js:5
#: src/utils/validation.js:13
msgid "validation:phone"
msgstr "validation:phone"

#. js-lingui-explicit-id
#: src/utils/validation.js:8
#: src/utils/validation.js:16
msgid "validation:phoneLength"
msgstr "validation:phoneLength"

#. js-lingui-explicit-id
#: src/utils/validation.js:23
#: src/utils/valid.ts:21
#: src/utils/i18n-legacy.ts:69
#: src/containers/Users/NewUser.tsx:40
msgid "validation:required"
msgstr "validation:required"

#. js-lingui-explicit-id
#: src/utils/validation.js:27
#: src/utils/valid.ts:16
msgid "validation:no_spaces"
msgstr "validation:no_spaces"

#. js-lingui-explicit-id
#: src/utils/validation.js:38
msgid "validation:one_lathin_lowercase_letter"
msgstr "validation:one_lathin_lowercase_letter"

#. js-lingui-explicit-id
#: src/utils/validation.js:39
msgid "validation:one_lathin_uppercase_letter"
msgstr "validation:one_lathin_uppercase_letter"

#. js-lingui-explicit-id
#: src/utils/validation.js:40
msgid "validation:one_digit"
msgstr "validation:one_digit"

#. js-lingui-explicit-id
#: src/utils/validation.js:41
msgid "validation:more_than_8_length"
msgstr "validation:more_than_8_length"

#. js-lingui-explicit-id
#: src/utils/validation.js:43
msgid "validation:password_must"
msgstr "validation:password_must"

#. js-lingui-explicit-id
#: src/utils/valid.ts:11
msgid "validation:only_lathin_alphanumeric"
msgstr "validation:only_lathin_alphanumeric"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:68
msgid "validation:invalid"
msgstr "validation:invalid"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:70
msgid "validation:notType"
msgstr "validation:notType"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:73
msgid "validation:min"
msgstr "validation:min"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:74
msgid "validation:max"
msgstr "validation:max"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:75
msgid "validation:moreThan"
msgstr "validation:moreThan"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:76
msgid "validation:lessThan"
msgstr "validation:lessThan"

#. js-lingui-explicit-id
#: src/utils/i18n-legacy.ts:79
msgid "validation:length"
msgstr "validation:length"

#. js-lingui-explicit-id
#: src/utils/error.ts:17
msgid "operation-error"
msgstr "operation-error"

#. js-lingui-explicit-id
#: src/utils/cartridge.ts:20
msgid "ui:units.volume"
msgstr "ui:units.volume"

#. js-lingui-explicit-id
#: src/utils/cartridge.ts:22
msgid "ui:units.hours"
msgstr "ui:units.hours"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:9
msgid "errors:incorrect_login_or_password"
msgstr "errors:incorrect_login_or_password"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:17
#: src/errors/userErrors.ts:23
msgid "errors:password_change_required"
msgstr "errors:password_change_required"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:29
msgid "errors:incorrect_confirmation_code"
msgstr "errors:incorrect_confirmation_code"

#. js-lingui-explicit-id
#: src/errors/userErrors.ts:35
msgid "errors:user_blocked"
msgstr "errors:user_blocked"

#. js-lingui-explicit-id
#: src/errors/baseErrors.js:7
msgid "errors:limit_reached"
msgstr "errors:limit_reached"

#. js-lingui-explicit-id
#: src/containers/Terminals/NewDevice/DeviceBaseFields.tsx:36
msgid "validation:incorrect_device_key"
msgstr "validation:incorrect_device_key"

#. js-lingui-explicit-id
#: src/containers/Profile/EditProfile.tsx:23
msgid "validation:email"
msgstr "validation:email"

#. js-lingui-explicit-id
#: src/containers/Profile/ChangePassword.tsx:20
msgid "login:message.password_mismatch"
msgstr "login:message.password_mismatch"

#. js-lingui-explicit-id
#: src/containers/DeviceList/columns/waterPlusColumns.tsx:46
msgid "ui:units.liters"
msgstr "ui:units.liters"

#. js-lingui-explicit-id
#: src/components/TerminalState.tsx:37
msgid "ui:yes"
msgstr "ui:yes"

#. js-lingui-explicit-id
#: src/components/TerminalState.tsx:37
msgid "ui:no"
msgstr "ui:no"

#. js-lingui-explicit-id
#: src/components/CartridgeValue/utils.ts:9
msgid "cartridges:step.OptionalMineralizer"
msgstr "cartridges:step.OptionalMineralizer"

#: src/containers/OraclePage/ComputeTab/utils.ts:247
msgid ""
"\n"
"\n"
"Детальный расчёт доходов (выручка):"
msgstr ""
"\n"
"\n"
"Детальный расчёт доходов (выручка):"

#: src/containers/OraclePage/ComputeTab/utils.ts:277
msgid ""
"\n"
"\n"
"Детальный расчёт расходов:"
msgstr ""
"\n"
"\n"
"Детальный расчёт расходов:"

#: src/containers/OraclePage/ComputeTab/utils.ts:328
msgid ""
"\n"
"Аренда:"
msgstr ""
"\n"
"Аренда:"

#: src/containers/OraclePage/ComputeTab/utils.ts:335
msgid ""
"\n"
"Вода:"
msgstr ""
"\n"
"Вода:"

#: src/containers/OraclePage/ComputeTab/utils.ts:266
msgid ""
"\n"
"Доход от рекламы:"
msgstr ""
"\n"
"Доход от рекламы:"

#: src/containers/OraclePage/ComputeTab/utils.ts:362
msgid ""
"\n"
"Мониторинг:"
msgstr ""
"\n"
"Мониторинг:"

#: src/containers/OraclePage/ComputeTab/utils.ts:464
msgid ""
"\n"
"Налогообложение:"
msgstr ""
"\n"
"Налогообложение:"

#: src/containers/OraclePage/ComputeTab/utils.ts:459
msgid ""
"\n"
"Обслуживание кредита:"
msgstr ""
"\n"
"Обслуживание кредита:"

#: src/containers/OraclePage/ComputeTab/utils.ts:422
msgid ""
"\n"
"Пересчёт монет:"
msgstr ""
"\n"
"Пересчёт монет:"

#: src/containers/OraclePage/ComputeTab/utils.ts:357
msgid ""
"\n"
"Персонал:"
msgstr ""
"\n"
"Персонал:"

#: src/containers/OraclePage/ComputeTab/utils.ts:263
msgid ""
"\n"
"Продажи:"
msgstr ""
"\n"
"Продажи:"

#: src/containers/OraclePage/ComputeTab/utils.ts:271
msgid ""
"\n"
"Прочие доходы:"
msgstr ""
"\n"
"Прочие доходы:"

#: src/containers/OraclePage/ComputeTab/utils.ts:412
msgid ""
"\n"
"Разовые расходы за период:"
msgstr ""
"\n"
"Разовые расходы за период:"

#: src/containers/OraclePage/ComputeTab/utils.ts:367
msgid ""
"\n"
"Фильтр 1 ступень:"
msgstr ""
"\n"
"Фильтр 1 ступень:"

#: src/containers/OraclePage/ComputeTab/utils.ts:372
msgid ""
"\n"
"Фильтр 2 ступень:"
msgstr ""
"\n"
"Фильтр 2 ступень:"

#: src/containers/OraclePage/ComputeTab/utils.ts:377
msgid ""
"\n"
"Фильтр 3 ступень:"
msgstr ""
"\n"
"Фильтр 3 ступень:"

#: src/containers/OraclePage/ComputeTab/utils.ts:382
msgid ""
"\n"
"Фильтр 4 ступень:"
msgstr ""
"\n"
"Фильтр 4 ступень:"

#: src/containers/OraclePage/ComputeTab/utils.ts:387
msgid ""
"\n"
"Фильтр 5 ступень:"
msgstr ""
"\n"
"Фильтр 5 ступень:"

#: src/containers/OraclePage/ComputeTab/utils.ts:392
msgid ""
"\n"
"Фильтр 6 ступень:"
msgstr ""
"\n"
"Фильтр 6 ступень:"

#: src/containers/OraclePage/ComputeTab/utils.ts:397
msgid ""
"\n"
"Фильтр 7 ступень:"
msgstr ""
"\n"
"Фильтр 7 ступень:"

#: src/containers/OraclePage/ComputeTab/utils.ts:402
msgid ""
"\n"
"Фильтр 8 ступень:"
msgstr ""
"\n"
"Фильтр 8 ступень:"

#: src/containers/OraclePage/ComputeTab/utils.ts:407
msgid ""
"\n"
"Фильтр 9 ступень:"
msgstr ""
"\n"
"Фильтр 9 ступень:"

#: src/containers/OraclePage/ComputeTab/utils.ts:439
msgid ""
"\n"
"Эквайринг:"
msgstr ""
"\n"
"Эквайринг:"

#: src/containers/OraclePage/ComputeTab/utils.ts:349
msgid ""
"\n"
"Электричество:"
msgstr ""
"\n"
"Электричество:"

#. placeholder {0}: formatMoney(sales.Exchange || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:178
msgid "- {0} [сдача]"
msgstr "- {0} [сдача]"

#. placeholder {0}: formatMoney(data.sales.Coins || 0, currency)
#. placeholder {1}: formatMoney( data.sales.Exchange || 0, currency )
#. placeholder {2}: formatMoney(diff, currency)
#. placeholder {3}: finStatementsForPeriod.CoinConversionFeeInPercent
#: src/containers/OraclePage/ComputeTab/utils.ts:425
msgid "[{0} монет - {1} сдачи = {2} монет, {3}% затраты на пересчёт монет]"
msgstr "[{0} монет - {1} сдачи = {2} монет, {3}% затраты на пересчёт монет]"

#. placeholder {0}: formatMoney( data.sales.Bankcard || 0, currency )
#. placeholder {1}: formatMoney( data.sales.MobileApp || 0, currency )
#. placeholder {2}: formatMoney(acquiringSum, currency)
#. placeholder {3}: finStatementsForPeriod.AcquiringFeeInPercent
#: src/containers/OraclePage/ComputeTab/utils.ts:442
msgid "[{0} оплат по банк. карте + {1} оплат по приложению = {2}, {3}% затраты на эквайринг]"
msgstr "[{0} оплат по банк. карте + {1} оплат по приложению = {2}, {3}% затраты на эквайринг]"

#. placeholder {0}: formatMoney( data.income, currency )
#. placeholder {1}: formatMoney( data.intermediateValues?.expensesTotalBeforeTaxes || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:482
msgid "[выбраны \"{type}\", доходы = {0}, затраты до вычета налогов = {1}]"
msgstr "[выбраны \"{type}\", доходы = {0}, затраты до вычета налогов = {1}]"

#: src/containers/OraclePage/ComputeTab/utils.ts:67
msgid "[Если нулевые значения кВт, возможно на терминале не подключена телеметрия]"
msgstr "[Если нулевые значения кВт, возможно на терминале не подключена телеметрия]"

#. placeholder {0}: finStatementsForPeriod.WaterConversionRatio
#: src/containers/OraclePage/ComputeTab/utils.ts:129
msgid "[Продано {litres} литров = {waterAfterConversionM3} м3, коэффициент конвертации воды = {0}, вода на входе до фильтрации = {waterBeforeConversionM3} м3]"
msgstr "[Продано {litres} литров = {waterAfterConversionM3} м3, коэффициент конвертации воды = {0}, вода на входе до фильтрации = {waterBeforeConversionM3} м3]"

#. placeholder {0}: months.toFixed(2)
#: src/containers/OraclePage/ComputeTab/utils.ts:31
msgid "{0, plural, one {# месяц} two {# месяца} few {# месяцев} other {# месяцев}}"
msgstr "{0, plural, one {# месяц} two {# месяца} few {# месяцев} other {# месяцев}}"

#: src/containers/Migrations/Migrations.tsx:3835
msgid "{megabytes} МБ"
msgstr "{megabytes} МБ"

#: src/containers/Terminals/Terminal/DeviceState/RemainWater/RemainWater.tsx:38
msgid "{percentValue} - значение вычислено на основе продаж"
msgstr "{percentValue} - значение вычислено на основе продаж"

#: src/containers/Migrations/Migrations.tsx:2617
msgid "{scopeLabel}: {migratedCount} аппаратов"
msgstr "{scopeLabel}: {migratedCount} аппаратов"

#: src/containers/Dashboard/BillingStats/columns.tsx:28
msgid "{value} из {Total}<0/> {percentFormatted}"
msgstr "{value} из {Total}<0/> {percentFormatted}"

#: src/locales/constants.ts:40
msgid "°"
msgstr "°"

#: src/locales/constants.ts:38
msgid "°C"
msgstr "°C"

#. placeholder {0}: formatMoney(data.intermediateValues?.expensesRental, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:280
msgid "+ {0} [аренда]"
msgstr "+ {0} [аренда]"

#. placeholder {0}: formatMoney(bankAndTaxation, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:323
msgid "+ {0} [банк и налогообложение]"
msgstr "+ {0} [банк и налогообложение]"

#. placeholder {0}: formatMoney(sales.Bankcard || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:174
msgid "+ {0} [банк. карта]"
msgstr "+ {0} [банк. карта]"

#. placeholder {0}: formatMoney(sales.Banknotes || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:172
msgid "+ {0} [банкноты]"
msgstr "+ {0} [банкноты]"

#. placeholder {0}: formatMoney(waterTotalExpenses, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:287
msgid "+ {0} [вода]"
msgstr "+ {0} [вода]"

#. placeholder {0}: formatMoney( data.intermediateValues?.incomeAdvertising || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:250
msgid "+ {0} [доходы от рекламы]"
msgstr "+ {0} [доходы от рекламы]"

#. placeholder {0}: formatMoney(sales.MobileApp || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:176
msgid "+ {0} [моб. приложение]"
msgstr "+ {0} [моб. приложение]"

#. placeholder {0}: formatMoney(sales.Coins || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:173
msgid "+ {0} [монеты]"
msgstr "+ {0} [монеты]"

#. placeholder {0}: formatMoney(pointMaintenance, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:298
msgid "+ {0} [обслуживание точки]"
msgstr "+ {0} [обслуживание точки]"

#. placeholder {0}: formatMoney(data.sales.Amount || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:248
msgid "+ {0} [продажи]"
msgstr "+ {0} [продажи]"

#. placeholder {0}: formatMoney( data.intermediateValues?.incomeOtherSources || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:256
msgid "+ {0} [прочие доходы]"
msgstr "+ {0} [прочие доходы]"

#. placeholder {0}: formatMoney( data.intermediateValues?.expensesOneTime || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:312
msgid "+ {0} [разовые расходы]"
msgstr "+ {0} [разовые расходы]"

#. placeholder {0}: formatMoney(cartridges, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:310
msgid "+ {0} [фильтры]"
msgstr "+ {0} [фильтры]"

#. placeholder {0}: formatMoney( data.intermediateValues?.expensesElectricityPerKwH || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:289
msgid "+ {0} [электричество]"
msgstr "+ {0} [электричество]"

#: src/containers/OraclePage/ComputeTab/utils.ts:78
msgid "+ {money} [{kwH} кВт c {fromStr} по {toStr}, {moneyPerWat} за кВт]"
msgstr "+ {money} [{kwH} кВт c {fromStr} по {toStr}, {moneyPerWat} за кВт]"

#: src/containers/OraclePage/ComputeTab/utils.ts:54
msgid "+ {money} [{month} c {fromStr} по {toStr}, {moneyPerMonth} в месяц]"
msgstr "+ {money} [{month} c {fromStr} по {toStr}, {moneyPerMonth} в месяц]"

#: src/containers/OraclePage/ComputeTab/utils.ts:157
msgid "+ {negativeImpactCostPerM3} [Негативное воздействие, {negativeImpactCost} за м3]"
msgstr "+ {negativeImpactCostPerM3} [Негативное воздействие, {negativeImpactCost} за м3]"

#: src/containers/OraclePage/ComputeTab/utils.ts:146
msgid "+ {wasteWaterCostPerM3} [Водоотведение, {wasteWaterCost} за м3]"
msgstr "+ {wasteWaterCostPerM3} [Водоотведение, {wasteWaterCost} за м3]"

#: src/containers/OraclePage/ComputeTab/utils.ts:136
msgid "+ {waterCostPerM3} [ХВС, {waterCost} за м3]"
msgstr "+ {waterCostPerM3} [ХВС, {waterCost} за м3]"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:90
msgid "<0> Аппарат <1>{deviceAddress}</1> будет удален безвозвратно.</0><2>Продолжить?</2>"
msgstr "<0> Аппарат <1>{deviceAddress}</1> будет удален безвозвратно.</0><2>Продолжить?</2>"

#. placeholder {0}: SUPPORT_LINKS.TG
#. placeholder {1}: SUPPORT_LINKS.Tell
#: src/containers/Login/LoginForm.tsx:120
msgid "<0>Для получения аккаунта в системе GSM мониторинга вам необходимо обратиться в службу технической поддержки по следующим каналам:</0><1><2>{0}</2></1><3><4>{1}</4></3><5>Техническая поддержка работает ежедневно, с 7:00 до 21:00 по Московскому времени. Оформление доступа в личный кабинет происходит <6>ТОЛЬКО</6> через переписку!</5>"
msgstr "<0>Для получения аккаунта в системе GSM мониторинга вам необходимо обратиться в службу технической поддержки по следующим каналам:</0><1><2>{0}</2></1><3><4>{1}</4></3><5>Техническая поддержка работает ежедневно, с 7:00 до 21:00 по Московскому времени. Оформление доступа в личный кабинет происходит <6>ТОЛЬКО</6> через переписку!</5>"

#: src/containers/Services/Recharge.tsx:130
msgid "<0>Нажимая на кнопку <1>Пополнить</1>, вы соглашаетесь с условиями <2>Оферты</2></0><3>Если вам необходимы отчетные документы по оказанным услугам (акт оказанных услуг и счет-фактура), просим оплату проводить платежным поручением с расчетного счета юридического лица, на указанные ниже реквизиты:<4>ИП Вяткин Вячеслав Владимирович ИНН 591600372797 Р/с <5/>40802810049770036699 в ВОЛГО-ВЯТСКИЙ БАНК ПАО СБЕРБАНК БИК<6/>042202603, к/с 30101810900000000603 Назначение платежа: \"4GSM Оплата информационного взаимодействия\"<7/></4><8>Для корректного зачисления платежа необходимо в профиле кабинета заполнить поле \"Налоговый идентификатор\"</8>При оплате банковской картой на сайте отчетные документы на реквизиты юридического лица предоставляться не будут.</3><9>Минимальная сумма платежа - {minPaymentSum}₽<10/>Максимальная сумма платежа - {maxPaymentSum}₽</9>"
msgstr "<0>Нажимая на кнопку <1>Пополнить</1>, вы соглашаетесь с условиями <2>Оферты</2></0><3>Если вам необходимы отчетные документы по оказанным услугам (акт оказанных услуг и счет-фактура), просим оплату проводить платежным поручением с расчетного счета юридического лица, на указанные ниже реквизиты:<4>ИП Вяткин Вячеслав Владимирович ИНН 591600372797 Р/с <5/>40802810049770036699 в ВОЛГО-ВЯТСКИЙ БАНК ПАО СБЕРБАНК БИК<6/>042202603, к/с 30101810900000000603 Назначение платежа: \"4GSM Оплата информационного взаимодействия\"<7/></4><8>Для корректного зачисления платежа необходимо в профиле кабинета заполнить поле \"Налоговый идентификатор\"</8>При оплате банковской картой на сайте отчетные документы на реквизиты юридического лица предоставляться не будут.</3><9>Минимальная сумма платежа - {minPaymentSum}₽<10/>Максимальная сумма платежа - {maxPaymentSum}₽</9>"

#: src/containers/Services/Recharge.tsx:191
msgid "<0>Обращаем ваше внимание, что денежные средства с вашей карты будут списаны в {currency}.  Сумма к списанию составляет <1>{formattedAmount}</1></0><2>Уважаемые клиенты компании \"Живая вода\".<3/>Хотим Вас проинформировать, что в связи с изменениями условий в одностороннем порядке банком партнером, с 01.08.2023 минимально возможная сумма для оплаты услуг GSM мониторинга составит в эквиваленте местной валюты 13 $<4/>Увеличение минимальной суммы платежа в 13 $ позволит Вам избежать комиссии банка в размере 1 $ с каждой оплаты.<5/>Наша Компания приложит все усилия над поиском альтернативных вариантов приема платежей по картам, эмитированным банками не резидентами РФ, в привычном Вам формате<6/></2>"
msgstr "<0>Обращаем ваше внимание, что денежные средства с вашей карты будут списаны в {currency}.  Сумма к списанию составляет <1>{formattedAmount}</1></0><2>Уважаемые клиенты компании \"Живая вода\".<3/>Хотим Вас проинформировать, что в связи с изменениями условий в одностороннем порядке банком партнером, с 01.08.2023 минимально возможная сумма для оплаты услуг GSM мониторинга составит в эквиваленте местной валюты 13 $<4/>Увеличение минимальной суммы платежа в 13 $ позволит Вам избежать комиссии банка в размере 1 $ с каждой оплаты.<5/>Наша Компания приложит все усилия над поиском альтернативных вариантов приема платежей по картам, эмитированным банками не резидентами РФ, в привычном Вам формате<6/></2>"

#: src/containers/Terminals/NewDevice/CreateNotAvailable.tsx:6
msgid "<0>С 30.05.202 для России и 01.10.2022 для других стран, операции, связанные добавлением оборудования будут доступны только через сотрудников технической поддержки.</0><1>С технической поддержкой можно связаться:<2><3>телеграмм <4>@ALIVEWATERNEWBOT</4></3></2></1><5>Для добавления оборудования вам необходимо указать следующую информацию:<6><7>логин к которому добавляется оборудование и наименование компании (так, как это указано в мониторинге)</7><8>IMEI аппарата</8><9>тип оборудования (доочистка или привозная)</9><10>номер симкарты, установленный в аппарате в формате +код страны</10><11>номер телефона (для России +7хххххххххх)</11><12>часовой пояс аппарата</12><13>валюта аппарата </13><14>телефон технической поддержки в формате + код страны</14><15>номер телефона (для России +7хххххххххх)</15><16>адрес установки аппарата в формате город, улица номер дома (строения)</16><17> стоимость воды за 1 л за наличные</17><18>стоимость воды за 1 л по IC карте</18></6></5>"
msgstr "<0>С 30.05.202 для России и 01.10.2022 для других стран, операции, связанные добавлением оборудования будут доступны только через сотрудников технической поддержки.</0><1>С технической поддержкой можно связаться:<2><3>телеграмм <4>@ALIVEWATERNEWBOT</4></3></2></1><5>Для добавления оборудования вам необходимо указать следующую информацию:<6><7>логин к которому добавляется оборудование и наименование компании (так, как это указано в мониторинге)</7><8>IMEI аппарата</8><9>тип оборудования (доочистка или привозная)</9><10>номер симкарты, установленный в аппарате в формате +код страны</10><11>номер телефона (для России +7хххххххххх)</11><12>часовой пояс аппарата</12><13>валюта аппарата </13><14>телефон технической поддержки в формате + код страны</14><15>номер телефона (для России +7хххххххххх)</15><16>адрес установки аппарата в формате город, улица номер дома (строения)</16><17> стоимость воды за 1 л за наличные</17><18>стоимость воды за 1 л по IC карте</18></6></5>"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:100
msgid "<0>С 30.05.2022 операции, связанные удалением оборудования будут доступны только через сотрудников технической поддержки.</0><1>С технической поддержкой можно связаться:<2><3>телеграмм <4>@ALIVEWATERNEWBOT</4></3></2></1><5>Для удаления аппарата необходимо указать следующую информацию:<6><7>логин у которого удаляется аппарат</7><8>наименование компании (так, как это указано в мониторинге)</8><9>IMEI удаляемого аппарата</9><10>причина удаления аппарата</10></6></5>"
msgstr "<0>С 30.05.2022 операции, связанные удалением оборудования будут доступны только через сотрудников технической поддержки.</0><1>С технической поддержкой можно связаться:<2><3>телеграмм <4>@ALIVEWATERNEWBOT</4></3></2></1><5>Для удаления аппарата необходимо указать следующую информацию:<6><7>логин у которого удаляется аппарат</7><8>наименование компании (так, как это указано в мониторинге)</8><9>IMEI удаляемого аппарата</9><10>причина удаления аппарата</10></6></5>"

#: src/containers/LowBalanceNotification/LowBalanceNotification.tsx:45
msgid "<0>Уважаемые пользователи GSM мониторинга!</0><1>Что бы избежать возможных сложностей при оплате услуг GSM мониторинга в начале месяца, настоятельно рекомендуем сделать очередной платеж за GSM мониторинг не позднее 25го числа текущего месяца.</1><2>Это позволит оперативно разобраться в проблеме, если она возникнет во время оплаты, и минимизировать время недоступности мониторинга для вас</2>"
msgstr "<0>Уважаемые пользователи GSM мониторинга!</0><1>Что бы избежать возможных сложностей при оплате услуг GSM мониторинга в начале месяца, настоятельно рекомендуем сделать очередной платеж за GSM мониторинг не позднее 25го числа текущего месяца.</1><2>Это позволит оперативно разобраться в проблеме, если она возникнет во время оплаты, и минимизировать время недоступности мониторинга для вас</2>"

#: src/components/ServiceNotificationModal.tsx:40
msgid "<0>Что это означает простыми словами?</0><1><2>Доступ к мониторингу платный и составляет <3>200 руб</3> за один аппарат в месяц. Метод расчетов - авансовый. Списание средств с баланса будет происходить первого числа ежемесячно в размере 200 руб * число аппаратов, зарегистрированных в мониторинге на дату списания.</2></1><4>В случае, если средств на балансе не хватает на все оборудование, доступ к личному кабинету будет приостановлен до пополнения баланса. Все описанное выше распространяется на оборудование, зарегистрированное в мониторинге до 06.2021.</4><5><6>При регистрации нового оборудования на ваш баланс будет начислена сумма 200 руб на каждую единицу оборудования</6><7>Операции связанные с добавлением и удалением оборудования с 01.06.2022 будут производиться ТОЛЬКО через службу технической поддержки.</7><8>Возможность принимать платежи через приложение и/или через QR код так же становится платной. Оплата составляет 100 руб/мес. Данную услугу вы можете самостоятельно подключить/отключить в мониторинге.</8></5><9>Первое списание денежных средств с баланса произойдёт 01.07.2022. До этого момента настоятельно рекомендуем вам пополнить ваш баланс в личном кабинете.</9>"
msgstr "<0>Что это означает простыми словами?</0><1><2>Доступ к мониторингу платный и составляет <3>200 руб</3> за один аппарат в месяц. Метод расчетов - авансовый. Списание средств с баланса будет происходить первого числа ежемесячно в размере 200 руб * число аппаратов, зарегистрированных в мониторинге на дату списания.</2></1><4>В случае, если средств на балансе не хватает на все оборудование, доступ к личному кабинету будет приостановлен до пополнения баланса. Все описанное выше распространяется на оборудование, зарегистрированное в мониторинге до 06.2021.</4><5><6>При регистрации нового оборудования на ваш баланс будет начислена сумма 200 руб на каждую единицу оборудования</6><7>Операции связанные с добавлением и удалением оборудования с 01.06.2022 будут производиться ТОЛЬКО через службу технической поддержки.</7><8>Возможность принимать платежи через приложение и/или через QR код так же становится платной. Оплата составляет 100 руб/мес. Данную услугу вы можете самостоятельно подключить/отключить в мониторинге.</8></5><9>Первое списание денежных средств с баланса произойдёт 01.07.2022. До этого момента настоятельно рекомендуем вам пополнить ваш баланс в личном кабинете.</9>"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:32
msgid "<0>Что это означает простыми словами?</0><1><2>У аппарата одна общая система водоподготовки и две камеры розлива, каждая из которых имеет свою плату управления. В системе мониторинга такой аппарат технически воспринимается как два отдельных устройства. Однако для удобства их данные иногда объединяются в одном интерфейсе.</2><3>Устройство с подключенной системой водоподготовки называют ГЛАВНЫМ, а второе, без собственной системы, — ВТОРИЧНЫМ.</3><4>Чтобы жизнь стала проще, изменения настроек платы управления главного устройства автоматически копирутся на вторичное. Но если нужно, настройки вторичного устройства можно скорректировать вручную.</4></1><5>Идея проста: Объединять такие аппараты в единое устройство там, где это удобно, и разделять их на два независимых элемента, когда это необходимо.</5>"
msgstr "<0>Что это означает простыми словами?</0><1><2>У аппарата одна общая система водоподготовки и две камеры розлива, каждая из которых имеет свою плату управления. В системе мониторинга такой аппарат технически воспринимается как два отдельных устройства. Однако для удобства их данные иногда объединяются в одном интерфейсе.</2><3>Устройство с подключенной системой водоподготовки называют ГЛАВНЫМ, а второе, без собственной системы, — ВТОРИЧНЫМ.</3><4>Чтобы жизнь стала проще, изменения настроек платы управления главного устройства автоматически копирутся на вторичное. Но если нужно, настройки вторичного устройства можно скорректировать вручную.</4></1><5>Идея проста: Объединять такие аппараты в единое устройство там, где это удобно, и разделять их на два независимых элемента, когда это необходимо.</5>"

#: src/containers/Terminals/EditDevice/BundleDeviceAdmin.tsx:206
msgid "<0>Это вторичное устройство. Редактируйте его на странице главного:</0><1><2>Перейти к главному устройству</2></1>"
msgstr "<0>Это вторичное устройство. Редактируйте его на странице главного:</0><1><2>Перейти к главному устройству</2></1>"

#: src/containers/Migrations/formatDuration.tsx:7
msgid "<1с"
msgstr "<1с"

#. placeholder {0}: formatMoney(acc, currency)
#. placeholder {0}: formatMoney(total, currency)
#. placeholder {0}: formatMoney(sales.Amount || 0, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:57
#: src/containers/OraclePage/ComputeTab/utils.ts:85
#: src/containers/OraclePage/ComputeTab/utils.ts:112
#: src/containers/OraclePage/ComputeTab/utils.ts:163
#: src/containers/OraclePage/ComputeTab/utils.ts:179
#: src/containers/OraclePage/ComputeTab/utils.ts:261
#: src/containers/OraclePage/ComputeTab/utils.ts:325
#: src/containers/OraclePage/ComputeTab/utils.ts:433
#: src/containers/OraclePage/ComputeTab/utils.ts:453
msgid "= {0}"
msgstr "= {0}"

#. placeholder {0}: formatMoney( data.intermediateValues?.expensesTax || 0, currency )
#: src/containers/OraclePage/ComputeTab/utils.ts:491
msgid "= {0} налог"
msgstr "= {0} налог"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:33
msgid "100 мл"
msgstr "100 мл"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:41
msgid "30 мл"
msgstr "30 мл"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:184
msgid "4x строчный"
msgstr "4x строчный"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:186
msgid "4x строчный и отображаются 10 доли"
msgstr "4x строчный и отображаются 10 доли"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:37
msgid "50 мл"
msgstr "50 мл"

#: src/containers/Dashboard/AllMoney/utils.ts:42
msgid "App/Qr"
msgstr "App/Qr"

#: src/locales/constants.ts:37
msgid "c."
msgstr "c."

#: src/containers/Migrations/Migrations.tsx:2853
msgid "Consumer Lag Kafka"
msgstr "Consumer Lag Kafka"

#: src/config/menu.tsx:30
msgid "Dashboard"
msgstr "Dashboard"

#: src/locales/constants.ts:45
msgid "Email"
msgstr "Email"

#: src/containers/Migrations/Migrations.tsx:2894
msgid "EWMA стоимости страницы"
msgstr "EWMA стоимости страницы"

#: src/locales/constants.ts:12
#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:67
#: src/containers/DeviceList/columns/desktop.tsx:62
msgid "IMEI"
msgstr "IMEI"

#: src/hooks/useTempreatureFormatter.ts:9
msgid "N/A"
msgstr "N/A"

#: src/containers/Migrations/Migrations.tsx:702
#: src/containers/Migrations/Migrations.tsx:994
msgid "Parquet, МБ (telemetry 6 мес., оценка)"
msgstr "Parquet, МБ (telemetry 6 мес., оценка)"

#: src/containers/Migrations/Migrations.tsx:3234
msgid "Parquet, МБ (telemetry 6 мес., суммарная оценка)"
msgstr "Parquet, МБ (telemetry 6 мес., суммарная оценка)"

#: src/containers/Migrations/Migrations.tsx:678
#: src/containers/Migrations/Migrations.tsx:966
msgid "Parquet, МБ (всё, оценка)"
msgstr "Parquet, МБ (всё, оценка)"

#: src/containers/Migrations/Migrations.tsx:3225
msgid "Parquet, МБ (всё, суммарная оценка)"
msgstr "Parquet, МБ (всё, суммарная оценка)"

#: src/containers/Migrations/Migrations.tsx:2807
msgid "Pod"
msgstr "Pod"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:86
msgid "Portal и worker вернутся к штатной обработке."
msgstr "Portal и worker вернутся к штатной обработке."

#: src/containers/Migrations/Migrations.tsx:708
#: src/containers/Migrations/Migrations.tsx:1000
msgid "PostgreSQL, МБ (telemetry 6 мес., оценка)"
msgstr "PostgreSQL, МБ (telemetry 6 мес., оценка)"

#: src/containers/Migrations/Migrations.tsx:3244
msgid "PostgreSQL, МБ (telemetry 6 мес., суммарная оценка)"
msgstr "PostgreSQL, МБ (telemetry 6 мес., суммарная оценка)"

#: src/containers/Migrations/Migrations.tsx:684
#: src/containers/Migrations/Migrations.tsx:974
msgid "PostgreSQL, МБ (всё, оценка)"
msgstr "PostgreSQL, МБ (всё, оценка)"

#: src/containers/Migrations/Migrations.tsx:3229
msgid "PostgreSQL, МБ (всё, суммарная оценка)"
msgstr "PostgreSQL, МБ (всё, суммарная оценка)"

#: src/locales/constants.ts:34
#: src/containers/DeviceList/columns/mobile.tsx:91
msgid "ppm"
msgstr "ppm"

#: src/components/ConnectBot/ConnectBot.tsx:179
msgid "Telegram пользователь успешно отвязан"
msgstr "Telegram пользователь успешно отвязан"

#: src/containers/Migrations/Migrations.tsx:696
#: src/containers/Migrations/Migrations.tsx:988
msgid "Telemetry mono за 6 месяцев"
msgstr "Telemetry mono за 6 месяцев"

#: src/containers/Migrations/Migrations.tsx:690
#: src/containers/Migrations/Migrations.tsx:980
msgid "Telemetry за 6 месяцев"
msgstr "Telemetry за 6 месяцев"

#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:26
msgid "Wi-Fi"
msgstr "Wi-Fi"

#: src/containers/Migrations/Migrations.tsx:3186
msgid "Автообновление каждые 20 секунд"
msgstr "Автообновление каждые 20 секунд"

#: src/containers/Migrations/Migrations.tsx:2996
msgid "Автообновление каждые 5 секунд"
msgstr "Автообновление каждые 5 секунд"

#: src/locales/constants.ts:5
#: src/containers/Encash/useEncashColumns.tsx:78
#: src/containers/DeviceList/columns/base.tsx:35
msgid "Адрес"
msgstr "Адрес"

#: src/locales/constants.ts:4
msgid "Адрес установки аппарата"
msgstr "Адрес установки аппарата"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:128
msgid "Активация аппарата прошла успешно"
msgstr "Активация аппарата прошла успешно"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:172
msgid "Активировать аппарат"
msgstr "Активировать аппарат"

#: src/containers/Migrations/Migrations.tsx:3091
msgid "Активные COPY"
msgstr "Активные COPY"

#: src/containers/Migrations/Migrations.tsx:2878
msgid "Активные Query"
msgstr "Активные Query"

#: src/containers/Dashboard/Users/Users.tsx:75
msgid "Активные за последние 2 месяца"
msgstr "Активные за последние 2 месяца"

#: src/containers/Dashboard/Users/Users.tsx:86
msgid "Активные за последние 2 месяца по группам"
msgstr "Активные за последние 2 месяца по группам"

#: src/containers/Dashboard/Users/Users.tsx:57
msgid "Активных за последние 2 месяца"
msgstr "Активных за последние 2 месяца"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:61
msgid "Акция"
msgstr "Акция"

#: src/containers/Terminals/Terminal/Device.tsx:122
msgid "Аналитика"
msgstr "Аналитика"

#: src/features/deviceAlerts/i18n/translations.ts:8
msgid "Аппарат давно не выходил на связь. Возможно, с ним есть определенные проблемы"
msgstr "Аппарат давно не выходил на связь. Возможно, с ним есть определенные проблемы"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:80
msgid "Аппарат обновлен"
msgstr "Аппарат обновлен"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:26
msgid "Аппарат с двумя камерами розлива"
msgstr "Аппарат с двумя камерами розлива"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:167
msgid "Аппарат требует активации службой технической поддержки"
msgstr "Аппарат требует активации службой технической поддержки"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:76
msgid "Аппарат удален"
msgstr "Аппарат удален"

#: src/containers/Migrations/Migrations.tsx:3927
msgid "Аппаратов"
msgstr "Аппаратов"

#: src/containers/Migrations/Migrations.tsx:3755
msgid "Аппаратов: {count}"
msgstr "Аппаратов: {count}"

#: src/containers/Migrations/Migrations.tsx:931
#: src/containers/Migrations/Migrations.tsx:3496
#: src/containers/Dashboard/Dashboard.tsx:37
#: src/config/menu.tsx:55
#: src/components/Stats/UserDevices.tsx:85
msgid "Аппараты"
msgstr "Аппараты"

#: src/containers/Migrations/SystemMigrations.tsx:229
#: src/containers/Migrations/SystemMigrations.tsx:234
msgid "Архив"
msgstr "Архив"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:82
#: src/containers/Terminals/NewDevice/DeviceBaseFields.tsx:191
msgid "Архивная версия платформы"
msgstr "Архивная версия платформы"

#: src/locales/constants.ts:36
msgid "атм"
msgstr "атм"

#: src/containers/Terminals/Terminal/Device.tsx:128
#: src/containers/DeviceList/constants.ts:27
msgid "Аудит"
msgstr "Аудит"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:105
#: src/containers/Services/Services.tsx:204
#: src/containers/Services/BalanceHistory.tsx:45
msgid "Баланс"
msgstr "Баланс"

#: src/containers/Terminals/EditDevice/WifiFields.tsx:47
msgid "Безопасность"
msgstr "Безопасность"

#: src/containers/Terminals/EditDevice/MainboardFields/BottlerFields.tsx:20
msgid "Блокировка при открытой дверце"
msgstr "Блокировка при открытой дверце"

#: src/components/ConnectBot/ConnectMaxBot.tsx:48
msgid "Бот на пермской площадке @AW_cyberbot_new"
msgstr "Бот на пермской площадке @AW_cyberbot_new"

#: src/components/ConnectBot/ConnectBot.tsx:49
msgid "Бот на пермской тестовой площадке @AwPermTestBot"
msgstr "Бот на пермской тестовой площадке @AwPermTestBot"

#. placeholder {0}: DateTime.fromMillis(device?.DeviceState.UpdatedAt ?? 0).toFormat('t')
#. placeholder {1}: t('ui:units.liters_per_minute', { value })
#: src/containers/Terminals/Terminal/DeviceState/TerminalWaterPrepare.tsx:131
msgid "в {0} - {1}"
msgstr "в {0} - {1}"

#. placeholder {2}: DateTime.fromMillis(device?.DeviceState.UpdatedAt ?? 0).toFormat('t')
#. placeholder {3}: t('ui:units.liters_per_minute', { value })
#: src/containers/Terminals/Terminal/DeviceState/TerminalWaterPrepare.tsx:142
msgid "в {2} - {3}"
msgstr "в {2} - {3}"

#: src/features/deviceAlerts/i18n/translations.ts:12
msgid "В аппарате более 2 часов не было продаж. Возможно, с ним есть определенные проблемы"
msgstr "В аппарате более 2 часов не было продаж. Возможно, с ним есть определенные проблемы"

#: src/containers/Encash/useEncashColumns.tsx:88
msgid "В купюрах"
msgstr "В купюрах"

#: src/containers/Encash/useEncashColumns.tsx:94
msgid "В монетах"
msgstr "В монетах"

#: src/containers/Users/UsersList.tsx:31
msgid "В сети"
msgstr "В сети"

#: src/containers/Sales/SalesTotal.tsx:115
msgid "в том числе обогащенной воды <0>{otherWaterLitres} ({otherWaterLitersPercent})</0> на <1>{otherWaterAmount} ({otherWaterAmountPercent})</1>"
msgstr "в том числе обогащенной воды <0>{otherWaterLitres} ({otherWaterLitersPercent})</0> на <1>{otherWaterAmount} ({otherWaterAmountPercent})</1>"

#: src/locales/constants.ts:11
msgid "Валюта"
msgstr "Валюта"

#: src/hooks/useCheckBalance.ts:36
msgid "Вам необходимо пополнить баланс лицевого счета для бесперебойной работы системы GSM мониторинга"
msgstr "Вам необходимо пополнить баланс лицевого счета для бесперебойной работы системы GSM мониторинга"

#: src/containers/OraclePage/EditDataTab/validationSchema.ts:12
msgid "Введите число"
msgstr "Введите число"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:76
msgid "Версия платы Водоподготовки"
msgstr "Версия платы Водоподготовки"

#: src/containers/Update/Update.tsx:50
msgid "Версия прошивки"
msgstr "Версия прошивки"

#: src/containers/Migrations/Migrations.tsx:3685
msgid "Визуализация"
msgstr "Визуализация"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:46
msgid "включена"
msgstr "включена"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:87
msgid "Включить"
msgstr "Включить"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:82
msgid "Включить технические работы?"
msgstr "Включить технические работы?"

#: src/locales/constants.ts:19
#: src/locales/constants.ts:23
#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:37
msgid "Владелец"
msgstr "Владелец"

#: src/features/demoAccess/ui/DemoAccessHint.tsx:10
msgid "Внимание! Это демонстрационный аккаунт. <0>Все адреса и суммы продаж вымышлены, любые совпадения с реальными адресами случайны</0>"
msgstr "Внимание! Это демонстрационный аккаунт. <0>Все адреса и суммы продаж вымышлены, любые совпадения с реальными адресами случайны</0>"

#: src/containers/DeviceList/columns/mobile.tsx:48
msgid "Вода"
msgstr "Вода"

#: src/containers/DeviceList/constants.ts:26
msgid "Вода+"
msgstr "Вода+"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:75
#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:23
msgid "Водоподготовка"
msgstr "Водоподготовка"

#: src/containers/Login/LoginForm.tsx:115
msgid "Войти"
msgstr "Войти"

#: src/containers/Login/LoginForm.tsx:117
msgid "Восстановить"
msgstr "Восстановить"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:93
#: src/containers/Services/BalanceHistory.tsx:25
msgid "Время"
msgstr "Время"

#: src/containers/Migrations/Migrations.tsx:2058
msgid "Время выполнения: {minutes} мин {seconds} сек"
msgstr "Время выполнения: {minutes} мин {seconds} сек"

#: src/containers/Migrations/Migrations.tsx:2059
msgid "Время выполнения: {seconds} сек"
msgstr "Время выполнения: {seconds} сек"

#: src/containers/Migrations/Migrations.tsx:731
#: src/containers/Migrations/Migrations.tsx:1026
msgid "Время миграции"
msgstr "Время миграции"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:141
msgid "Время набора раствора для промывки в мембрану"
msgstr "Время набора раствора для промывки в мембрану"

#: src/containers/Migrations/Migrations.tsx:714
#: src/containers/Migrations/Migrations.tsx:1006
msgid "Время оценки"
msgstr "Время оценки"

#. placeholder {0}: data.firstSaleTs ? convertTimestampToLocalDateString(data.firstSaleTs) : 'нет продаж'
#: src/containers/OraclePage/ComputeTab/utils.ts:214
msgid "Время первой продажи: {0}"
msgstr "Время первой продажи: {0}"

#: src/hooks/useGroupsOptions.tsx:13
msgid "Все группы"
msgstr "Все группы"

#: src/containers/Migrations/Migrations.tsx:3812
msgid "Все данные полностью"
msgstr "Все данные полностью"

#: src/containers/Migrations/Migrations.tsx:3169
msgid "Все размеры приблизительные. В варианте «telemetry 6 мес.» только telemetry и telemetry mono ограничены шестью месяцами, остальные данные учитываются полностью."
msgstr "Все размеры приблизительные. В варианте «telemetry 6 мес.» только telemetry и telemetry mono ограничены шестью месяцами, остальные данные учитываются полностью."

#: src/containers/Encash/useEncashColumns.tsx:82
#: src/containers/DeviceList/columns/list.tsx:69
#: src/containers/Dashboard/AllMoney/utils.ts:29
#: src/containers/Dashboard/AllMoney/utils.ts:57
msgid "Всего"
msgstr "Всего"

#: src/containers/Migrations/Migrations.tsx:3213
#: src/containers/Dashboard/Devices/utils.ts:59
msgid "Всего аппаратов"
msgstr "Всего аппаратов"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:126
msgid "Всего в аппарате"
msgstr "Всего в аппарате"

#: src/containers/Sales/SalesTotal.tsx:103
msgid "Всего за период <0>{formattedTotal}{delimiter}{formattedLiters}{wats}{liters}</0>"
msgstr "Всего за период <0>{formattedTotal}{delimiter}{formattedLiters}{wats}{liters}</0>"

#: src/containers/Encash/Encash.tsx:70
msgid "Всего за период <0>{formattedTotal}</0>"
msgstr "Всего за период <0>{formattedTotal}</0>"

#: src/containers/Dashboard/Users/Users.tsx:70
msgid "Всего зарегистрированных"
msgstr "Всего зарегистрированных"

#: src/containers/Migrations/Migrations.tsx:3209
msgid "Всего пользователей"
msgstr "Всего пользователей"

#: src/containers/Dashboard/Users/Users.tsx:49
msgid "Всего пользователей:"
msgstr "Всего пользователей:"

#: src/containers/Dashboard/BillingStats/columns.tsx:57
msgid "Всего счетов к обработке"
msgstr "Всего счетов к обработке"

#: src/containers/Dashboard/Geography/Geography.tsx:20
msgid "Всего устройств"
msgstr "Всего устройств"

#: src/containers/KnowledgeBase/Section.tsx:42
msgid "Вся база знаний"
msgstr "Вся база знаний"

#. placeholder {0}: convertTimestampToLocalDateString( data.period.userFromTs )
#. placeholder {1}: convertTimestampToLocalDateString(data.period.userToTs)
#: src/containers/OraclePage/ComputeTab/utils.ts:222
msgid "Вы выбрали Период с {0} по {1}."
msgstr "Вы выбрали Период с {0} по {1}."

#: src/containers/Terminals/EditDevice/PromoField.tsx:15
msgid "Вы выключили режим Промоакция. Параметр Автостоп наличные/банк.карта установлен равным 0 литров"
msgstr "Вы выключили режим Промоакция. Параметр Автостоп наличные/банк.карта установлен равным 0 литров"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:93
msgid "Вы меняете показания: {metertLabel}"
msgstr "Вы меняете показания: {metertLabel}"

#: src/containers/Encash/EncashComment.tsx:41
msgid "Вы можете добавить комментарий"
msgstr "Вы можете добавить комментарий"

#: src/containers/Dashboard/BillingStats/BillingStats.tsx:38
msgid "Выберите месяц за который хотите получить отчет"
msgstr "Выберите месяц за который хотите получить отчет"

#: src/locales/constants.ts:7
msgid "Выберите точный адрес установки из списка"
msgstr "Выберите точный адрес установки из списка"

#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:63
msgid "Выберите услугу"
msgstr "Выберите услугу"

#: src/containers/Migrations/Migrations.tsx:2616
msgid "Выборочная миграция завершена"
msgstr "Выборочная миграция завершена"

#: src/components/LastServiceDate/LastServiceDate.tsx:152
msgid "Выбранная дата обслуживания установится для ВСЕХ аппаратов в личном кабинете"
msgstr "Выбранная дата обслуживания установится для ВСЕХ аппаратов в личном кабинете"

#: src/containers/Migrations/Migrations.tsx:1075
msgid "Выгружает полную историю в Parquet, импортирует её в PostgreSQL и сохраняет резервную копию в MinIO"
msgstr "Выгружает полную историю в Parquet, импортирует её в PostgreSQL и сохраняет резервную копию в MinIO"

#: src/containers/Migrations/SystemMigrations.tsx:204
msgid "Выгружено записей"
msgstr "Выгружено записей"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:97
msgid "Выгрузить ручные корректировки"
msgstr "Выгрузить ручные корректировки"

#: src/containers/Migrations/SystemMigrations.tsx:219
msgid "Выгрузка"
msgstr "Выгрузка"

#: src/containers/Migrations/SystemMigrations.tsx:48
msgid "Выгрузка в Parquet"
msgstr "Выгрузка в Parquet"

#: src/containers/Migrations/Migrations.tsx:265
#: src/containers/Migrations/Migrations.tsx:1229
#: src/containers/Migrations/Migrations.tsx:3390
msgid "Выгрузка из MinIO"
msgstr "Выгрузка из MinIO"

#: src/containers/Migrations/Migrations.tsx:1217
msgid "Выгрузка истории из DynamoDB"
msgstr "Выгрузка истории из DynamoDB"

#: src/containers/Migrations/Migrations.tsx:1215
msgid "Выгрузка текущего состояния из DynamoDB"
msgstr "Выгрузка текущего состояния из DynamoDB"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:50
msgid "выключена"
msgstr "выключена"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:30
msgid "Выключено"
msgstr "Выключено"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:87
msgid "Выключить"
msgstr "Выключить"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:83
msgid "Выключить технические работы?"
msgstr "Выключить технические работы?"

#: src/containers/Migrations/SystemMigrations.tsx:41
#: src/containers/Migrations/SystemMigrations.tsx:103
#: src/containers/Migrations/Migrations.tsx:266
#: src/containers/Migrations/Migrations.tsx:283
#: src/containers/Migrations/Migrations.tsx:1175
#: src/containers/Migrations/Migrations.tsx:2782
msgid "Выполняется"
msgstr "Выполняется"

#: src/containers/Migrations/Migrations.tsx:1186
msgid "Выполняется для"
msgstr "Выполняется для"

#: src/containers/Sales/Sales.tsx:145
msgid "Выслать общий отчет"
msgstr "Выслать общий отчет"

#: src/containers/Sales/Sales.tsx:138
msgid "Выслать отчет о продажах"
msgstr "Выслать отчет о продажах"

#: src/containers/Dashboard/AllMoney/utils.ts:19
msgid "Гарантийное оборудование"
msgstr "Гарантийное оборудование"

#: src/containers/Dashboard/Dashboard.tsx:31
msgid "География"
msgstr "География"

#: src/config/menu.tsx:36
msgid "Главная"
msgstr "Главная"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:156
msgid "Голосовой помощник"
msgstr "Голосовой помощник"

#: src/locales/constants.ts:49
msgid "Группа"
msgstr "Группа"

#: src/containers/Dashboard/Devices/Devices.tsx:41
#: src/containers/Dashboard/AllMoney/AllMoney.tsx:80
msgid "Группа:"
msgstr "Группа:"

#: src/config/menu.tsx:48
msgid "Группы пользователей"
msgstr "Группы пользователей"

#: src/ui-kit/Form/Switch/Switch.tsx:138
#: src/components/Switch.tsx:80
msgid "Да"
msgstr "Да"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:113
msgid "Данные"
msgstr "Данные"

#: src/utils/http.ts:22
msgid "Данные не доступны в демо-режиме"
msgstr "Данные не доступны в демо-режиме"

#: src/containers/Staff/StaffForm.tsx:35
msgid "Данные о сотруднике обновлены"
msgstr "Данные о сотруднике обновлены"

#: src/containers/Staff/StaffForm.tsx:57
msgid "Данные о сотруднике удалены"
msgstr "Данные о сотруднике удалены"

#: src/containers/Encash/useEncashColumns.tsx:104
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:10
msgid "Дата"
msgstr "Дата"

#: src/containers/StoreOrders/StoreOrders.tsx:103
msgid "Дата доставки"
msgstr "Дата доставки"

#: src/locales/constants.ts:14
#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:49
#: src/containers/Terminals/EditDevice/EditDevice.tsx:162
msgid "Дата обслуживания"
msgstr "Дата обслуживания"

#: src/components/LastServiceDate/LastServiceDate.tsx:106
msgid "Дата последнего обслуживания обновлена"
msgstr "Дата последнего обслуживания обновлена"

#: src/containers/Migrations/Migrations.tsx:3924
msgid "Дата создания"
msgstr "Дата создания"

#: src/containers/Migrations/Migrations.tsx:755
msgid "Дата создания аппарата"
msgstr "Дата создания аппарата"

#: src/containers/Migrations/Migrations.tsx:1045
msgid "Дата создания пользователя"
msgstr "Дата создания пользователя"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:121
msgid "Датчик столба жидкости"
msgstr "Датчик столба жидкости"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:68
msgid "Датчики"
msgstr "Датчики"

#: src/containers/OraclePage/EditDataTab/validationSchema.ts:21
msgid "Даты не должны быть одинаковыми"
msgstr "Даты не должны быть одинаковыми"

#: src/containers/DeviceList/columns/base.tsx:44
msgid "двухкамерный"
msgstr "двухкамерный"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:180
#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:94
msgid "двухстрочный"
msgstr "двухстрочный"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:182
msgid "двухстрочный моргающий"
msgstr "двухстрочный моргающий"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:98
msgid "двухстрочный по очереди"
msgstr "двухстрочный по очереди"

#: src/containers/Migrations/SystemMigrations.tsx:278
#: src/containers/Migrations/Migrations.tsx:602
#: src/containers/Migrations/Migrations.tsx:836
#: src/containers/Migrations/Migrations.tsx:3407
#: src/containers/Migrations/Migrations.tsx:3608
msgid "Действия"
msgstr "Действия"

#: src/components/Stats/constants.ts:11
msgid "День"
msgstr "День"

#: src/containers/DeviceList/constants.ts:23
#: src/containers/DeviceList/columns/mobile.tsx:143
#: src/containers/DeviceList/columns/desktop.tsx:143
#: src/containers/Dashboard/Dashboard.tsx:25
#: src/components/Stats/constants.ts:17
msgid "Деньги"
msgstr "Деньги"

#: src/containers/Migrations/Migrations.tsx:3165
msgid "Детали миграции"
msgstr "Детали миграции"

#: src/containers/Dashboard/Dashboard.tsx:28
msgid "Динамика билинга"
msgstr "Динамика билинга"

#: src/containers/DeviceList/constants.ts:28
msgid "Динамика продаж"
msgstr "Динамика продаж"

#: src/containers/Migrations/Migrations.tsx:2846
msgid "Диск pod: свободно / всего"
msgstr "Диск pod: свободно / всего"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:120
msgid "Диффузионная промывка"
msgstr "Диффузионная промывка"

#: src/containers/Migrations/Migrations.tsx:3271
msgid "Длительности суммируются по пользователям. Этапы конвейера выполняются параллельно, поэтому фактическое календарное время миграции может быть меньше указанного."
msgstr "Длительности суммируются по пользователям. Этапы конвейера выполняются параллельно, поэтому фактическое календарное время миграции может быть меньше указанного."

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:140
msgid "Длительность набора состава сек"
msgstr "Длительность набора состава сек"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:148
msgid "Длительность промывки ХВС {tflUnit}"
msgstr "Длительность промывки ХВС {tflUnit}"

#: src/containers/Login/LoginForm.tsx:109
msgid "Для demo-доступа используйте <0>demo</0> в качестве логина и любой пароль"
msgstr "Для demo-доступа используйте <0>demo</0> в качестве логина и любой пароль"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:69
msgid "Для аппарата на дату {SunCalcDate} время рассвета:{SunCalcSunrise}, время заката: {SunCalcSunset} (выкл/вкл подсветки произойдет в течение часа после рассвета/заката, соответственно)"
msgstr "Для аппарата на дату {SunCalcDate} время рассвета:{SunCalcSunrise}, время заката: {SunCalcSunset} (выкл/вкл подсветки произойдет в течение часа после рассвета/заката, соответственно)"

#: src/containers/Services/Services.tsx:251
msgid "Для вас нет доступных услуг"
msgstr "Для вас нет доступных услуг"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:351
msgid "Для временных меток показана разница в секундах: PostgreSQL минус DynamoDB. Положительное значение означает, что метка PostgreSQL позже, отрицательное — раньше."
msgstr "Для временных меток показана разница в секундах: PostgreSQL минус DynamoDB. Положительное значение означает, что метка PostgreSQL позже, отрицательное — раньше."

#: src/containers/Staff/Staff.tsx:38
msgid "Для добавления, изменения, удаления данных о сотрудниках необходимо обратиться в техническую поддержку телеграмм <0>@alivewaternewbot</0>"
msgstr "Для добавления, изменения, удаления данных о сотрудниках необходимо обратиться в техническую поддержку телеграмм <0>@alivewaternewbot</0>"

#: src/features/deviceAlerts/i18n/translations.ts:20
msgid "Для корректной работы оборудования вам необходимо его перезагрузить"
msgstr "Для корректной работы оборудования вам необходимо его перезагрузить"

#: src/containers/Services/Services.tsx:113
msgid "Для отображения данных, на балансе лицевого счета недостаточно средств"
msgstr "Для отображения данных, на балансе лицевого счета недостаточно средств"

#: src/containers/Migrations/Migrations.tsx:3103
msgid "Для таблиц от 10 000 строк данные распределяются между подключениями. Ноль приостанавливает запуск новых записей; уже начатая запись завершится."
msgstr "Для таблиц от 10 000 строк данные распределяются между подключениями. Ноль приостанавливает запуск новых записей; уже начатая запись завершится."

#: src/containers/OraclePage/EditDataTab/OracleHistoryInput/HistoryDataForm/HistoryDataForm.tsx:126
msgid "Добавить новую запись"
msgstr "Добавить новую запись"

#: src/containers/Staff/Staff.tsx:33
msgid "Добавить сотрудника"
msgstr "Добавить сотрудника"

#: src/containers/Migrations/Migrations.tsx:3519
msgid "Добавлено аппаратов: {addedDeviceCount}"
msgstr "Добавлено аппаратов: {addedDeviceCount}"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:335
msgid "Добавлено в PostgreSQL"
msgstr "Добавлено в PostgreSQL"

#: src/containers/Migrations/Migrations.tsx:3333
msgid "Добавлено пользователей: {synchronizedCount}; удалено из DynamoDB: {deletedUserCount}; восстановлено: {restoredUserCount}"
msgstr "Добавлено пользователей: {synchronizedCount}; удалено из DynamoDB: {deletedUserCount}; восстановлено: {restoredUserCount}"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:110
msgid "Добро пожаловать"
msgstr "Добро пожаловать"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:114
msgid "Добро пожаловать + номер техподдержки"
msgstr "Добро пожаловать + номер техподдержки"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:76
msgid "Добро пожаловать в 1 строке и номер техподдержки в 3-4 строках"
msgstr "Добро пожаловать в 1 строке и номер техподдержки в 3-4 строках"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:68
msgid "Добро пожаловать в 1 строке."
msgstr "Добро пожаловать в 1 строке."

#: src/locales/constants.ts:22
msgid "Долгота"
msgstr "Долгота"

#: src/config/menu.tsx:80
msgid "Домашние системы очистки"
msgstr "Домашние системы очистки"

#: src/locales/constants.ts:46
msgid "Дополнительно высылать отчеты на следующие адреса"
msgstr "Дополнительно высылать отчеты на следующие адреса"

#: src/components/ServiceNotificationModal.tsx:34
msgid "Доступ к GSM мониторингу предоставляется на платной основе"
msgstr "Доступ к GSM мониторингу предоставляется на платной основе"

#: src/containers/DeviceList/DeviceList.tsx:178
msgid "Доступно только для оборудования с оригинальной платой водоподготовки Живая вода"
msgstr "Доступно только для оборудования с оригинальной платой водоподготовки Живая вода"

#: src/containers/Dashboard/AllMoney/utils.ts:52
msgid "Другие"
msgstr "Другие"

#: src/components/CartridgeValue/EditValueModal.tsx:158
msgid "Если вы заменили счетчик ХВС - нажмите на эту кнопку. Это важно чтобы корректно рассчитать ОСТАЛОСЬ ДО ЗАМЕНЫ у картриджей 1-3 ступеней очистки"
msgstr "Если вы заменили счетчик ХВС - нажмите на эту кнопку. Это важно чтобы корректно рассчитать ОСТАЛОСЬ ДО ЗАМЕНЫ у картриджей 1-3 ступеней очистки"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:108
msgid "Живая вода"
msgstr "Живая вода"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:64
msgid "Живая вода в 1 строке"
msgstr "Живая вода в 1 строке"

#. placeholder {0}: DateTime.fromMillis(Number(date)) .setLocale('ru-ru') .toFormat('dd-MM-yyyy')
#: src/containers/Report/Report.tsx:57
msgid "за {0}"
msgstr "за {0}"

#: src/containers/Services/Services.tsx:185
msgid "За каждую ДСО, указанную на данной вкладке, удерживается {hwtPrice} в месяц за сервис GPS-МОНИТОРИНГ КОНТРОЛЯ ПАРАМЕТРОВ ОБОРУДОВАНИЯ - ДСО."
msgstr "За каждую ДСО, указанную на данной вкладке, удерживается {hwtPrice} в месяц за сервис GPS-МОНИТОРИНГ КОНТРОЛЯ ПАРАМЕТРОВ ОБОРУДОВАНИЯ - ДСО."

#: src/containers/Services/Services.tsx:173
msgid "За каждый аппарат, указанный на данной вкладке, удерживается {moniProPrice} в месяц за сервис GPS-МОНИТОРИНГ КОНТРОЛЯ ПАРАМЕТРОВ ОБОРУДОВАНИЯ. Если у вас нет необходимости в использовании этого сервиса для конкретного аппарата - вам необходимо удалить аппарат из системы. Для удаления - обратитесь в службу технической поддержки."
msgstr "За каждый аппарат, указанный на данной вкладке, удерживается {moniProPrice} в месяц за сервис GPS-МОНИТОРИНГ КОНТРОЛЯ ПАРАМЕТРОВ ОБОРУДОВАНИЯ. Если у вас нет необходимости в использовании этого сервиса для конкретного аппарата - вам необходимо удалить аппарат из системы. Для удаления - обратитесь в службу технической поддержки."

#: src/containers/OraclePage/ComputeTab/utils.ts:237
msgid "За это время не было продаж и расходов (расходы считаются только там где есть продажи):"
msgstr "За это время не было продаж и расходов (расходы считаются только там где есть продажи):"

#: src/containers/OraclePage/ComputeTab/utils.ts:234
msgid "За это время:"
msgstr "За это время:"

#: src/containers/Users/UserMenu.tsx:164
#: src/containers/Users/UserMenu.tsx:215
msgid "Заблокировать"
msgstr "Заблокировать"

#: src/containers/Users/UserMenu.tsx:163
msgid "Заблокировать пользователя?"
msgstr "Заблокировать пользователя?"

#: src/containers/Migrations/SystemMigrations.tsx:42
#: src/containers/Migrations/Migrations.tsx:267
#: src/containers/Migrations/Migrations.tsx:284
msgid "Завершена"
msgstr "Завершена"

#: src/containers/Migrations/SystemMigrations.tsx:80
msgid "Завершение"
msgstr "Завершение"

#: src/containers/Migrations/Migrations.tsx:1235
msgid "Завершение миграции"
msgstr "Завершение миграции"

#: src/containers/Migrations/MigrationDailyChart.tsx:74
msgid "Завершённые миграции по дням"
msgstr "Завершённые миграции по дням"

#: src/containers/Migrations/SystemMigrations.tsx:51
#: src/containers/Migrations/SystemMigrations.tsx:104
msgid "Завершено"
msgstr "Завершено"

#: src/containers/Migrations/Migrations.tsx:1225
msgid "Загрузка истории в PostgreSQL"
msgstr "Загрузка истории в PostgreSQL"

#: src/containers/Migrations/SystemMigrations.tsx:127
msgid "Загрузка статуса…"
msgstr "Загрузка статуса…"

#: src/containers/Migrations/Migrations.tsx:1219
msgid "Загрузка текущего состояния в PostgreSQL"
msgstr "Загрузка текущего состояния в PostgreSQL"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:96
#: src/components/Stats/UserDevices.tsx:93
msgid "Загрузка..."
msgstr "Загрузка..."

#: src/containers/StoreOrders/StoreOrders.tsx:99
msgid "Заказ #{orderNumber}"
msgstr "Заказ #{orderNumber}"

#: src/features/deviceAlerts/i18n/translations.ts:9
msgid "Закончилась вода в баке. Возможно, отключен водопровод или имеются другие проблемы с аппаратом"
msgstr "Закончилась вода в баке. Возможно, отключен водопровод или имеются другие проблемы с аппаратом"

#: src/containers/Sales/DeviceIncome.tsx:62
#: src/containers/Omnidesk/OmniChat.tsx:46
msgid "Закрыть"
msgstr "Закрыть"

#: src/containers/Migrations/Migrations.tsx:1223
msgid "Замена monotonic telemetry в PostgreSQL"
msgstr "Замена monotonic telemetry в PostgreSQL"

#: src/components/CartridgeValue/EditValueModal.tsx:57
#: src/components/CartridgeValue/EditValueModal.tsx:199
msgid "Замена картриджа {name}"
msgstr "Замена картриджа {name}"

#: src/containers/Migrations/SystemMigrations.tsx:207
msgid "Записано в Redis"
msgstr "Записано в Redis"

#: src/containers/Migrations/SystemMigrations.tsx:49
msgid "Запись в Redis"
msgstr "Запись в Redis"

#: src/containers/Migrations/Migrations.tsx:1335
msgid "Запустить миграцию"
msgstr "Запустить миграцию"

#: src/containers/Migrations/Migrations.tsx:1325
msgid "Запустить оценку"
msgstr "Запустить оценку"

#: src/containers/Migrations/Migrations.tsx:3269
msgid "Затрачено на миграцию, чч:мм:сс (≈)"
msgstr "Затрачено на миграцию, чч:мм:сс (≈)"

#: src/containers/Migrations/Migrations.tsx:3253
msgid "Затрачено на оценку, чч:мм:сс"
msgstr "Затрачено на оценку, чч:мм:сс"

#: src/containers/Migrations/Migrations.tsx:3046
msgid "Значение сохраняется после отпускания ползунка. Ноль приостанавливает новые запросы к DynamoDB."
msgstr "Значение сохраняется после отпускания ползунка. Ноль приостанавливает новые запросы к DynamoDB."

#: src/containers/SystemMaintenance/MaintenancePage.tsx:13
msgid "Идут технические работы"
msgstr "Идут технические работы"

#: src/components/EditAuditComment/EditAuditCommentModal.tsx:70
msgid "Изменение комментария"
msgstr "Изменение комментария"

#: src/containers/Migrations/Migrations.tsx:3518
msgid "Изменено аппаратов: {synchronizedDeviceCount}"
msgstr "Изменено аппаратов: {synchronizedDeviceCount}"

#: src/containers/Services/ChangeBalance.tsx:60
msgid "Изменить"
msgstr "Изменить"

#: src/components/LastServiceDate/LastServiceDate.tsx:143
msgid "Изменить дату обслуживания: {Address}"
msgstr "Изменить дату обслуживания: {Address}"

#: src/components/LastServiceDate/LastServiceDate.tsx:151
msgid "Изменить для всех"
msgstr "Изменить для всех"

#: src/containers/Migrations/Migrations.tsx:3368
msgid "Изменить статус миграции"
msgstr "Изменить статус миграции"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:85
msgid "Изменяющие запросы portal и обработка сообщений worker будут приостановлены."
msgstr "Изменяющие запросы portal и обработка сообщений worker будут приостановлены."

#: src/containers/Migrations/SystemMigrations.tsx:224
msgid "Импорт"
msgstr "Импорт"

#: src/locales/constants.ts:28
msgid "импульс/кВт"
msgstr "импульс/кВт"

#: src/locales/constants.ts:29
msgid "импульс/литр"
msgstr "импульс/литр"

#: src/locales/constants.ts:48
msgid "Имя"
msgstr "Имя"

#: src/containers/Terminals/EditDevice/WifiFields.tsx:41
msgid "Имя сети (SSID)"
msgstr "Имя сети (SSID)"

#: src/components/ConnectBot/ConnectMaxBot.tsx:46
#: src/components/ConnectBot/ConnectMaxBot.tsx:263
#: src/components/ConnectBot/ConnectMaxBot.tsx:269
#: src/components/ConnectBot/ConnectBot.tsx:47
#: src/components/ConnectBot/ConnectBot.tsx:273
#: src/components/ConnectBot/ConnectBot.tsx:279
msgid "Имя скрыто"
msgstr "Имя скрыто"

#: src/containers/Terminals/Terminal/Device.tsx:103
#: src/containers/Migrations/Migrations.tsx:654
#: src/containers/Migrations/Migrations.tsx:942
#: src/containers/Migrations/Migrations.tsx:3818
#: src/config/menu.tsx:67
msgid "Инкассации"
msgstr "Инкассации"

#: src/containers/Main/Header.tsx:136
msgid "Интернет магазин"
msgstr "Интернет магазин"

#: src/containers/Terminals/EditDevice/EditDeviceTabs.tsx:65
msgid "Информация"
msgstr "Информация"

#: src/containers/OraclePage/EditDataTab/OracleHistoryInput/HistoryDataForm/HistoryDataForm.tsx:85
msgid "исторические данные"
msgstr "исторические данные"

#: src/containers/Services/BalanceHistory.tsx:102
msgid "История операций"
msgstr "История операций"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:360
msgid "Как рассчитывается разница"
msgstr "Как рассчитывается разница"

#: src/containers/Services/PaymentType.tsx:41
#: src/containers/Services/PaymentType.tsx:42
msgid "Карты эмитированные банками РФ"
msgstr "Карты эмитированные банками РФ"

#: src/containers/Services/PaymentType.tsx:40
msgid "Карты эмитированные иностранными банками"
msgstr "Карты эмитированные иностранными банками"

#: src/locales/constants.ts:31
msgid "кВт*час"
msgstr "кВт*час"

#: src/locales/constants.ts:30
msgid "кВт/час"
msgstr "кВт/час"

#: src/containers/Migrations/SystemMigrations.tsx:145
#: src/containers/Migrations/SystemMigrations.tsx:265
msgid "Ключи Redis"
msgstr "Ключи Redis"

#: src/containers/Login/LoginForm.tsx:50
msgid "Код восстановления выслан на почту"
msgstr "Код восстановления выслан на почту"

#: src/containers/Users/UserMenu.tsx:78
msgid "Код для смены пароля отправлен"
msgstr "Код для смены пароля отправлен"

#: src/containers/StoreOrders/StoreOrders.tsx:111
msgid "Код отслеживания"
msgstr "Код отслеживания"

#: src/containers/Migrations/Migrations.tsx:3794
msgid "Кол-во"
msgstr "Кол-во"

#: src/containers/Dashboard/Devices/utils.ts:69
msgid "Количество активный аппаратов"
msgstr "Количество активный аппаратов"

#: src/containers/UserGroups/useUserGroupColumns.tsx:63
msgid "Количество активных аппаратов"
msgstr "Количество активных аппаратов"

#: src/containers/UserGroups/useUserGroupColumns.tsx:58
#: src/containers/Migrations/Migrations.tsx:3732
#: src/containers/Dashboard/Devices/Devices.tsx:54
msgid "Количество аппаратов"
msgstr "Количество аппаратов"

#: src/containers/Terminals/Terminal/DeviceState/BotlerStatus.tsx:24
msgid "Количество бутылок в ячейках"
msgstr "Количество бутылок в ячейках"

#: src/containers/UserGroups/useUserGroupColumns.tsx:53
msgid "Количество пользователей"
msgstr "Количество пользователей"

#: src/containers/Migrations/MigrationDailyChart.tsx:77
msgid "Количество пользователей по дате завершения миграции. Даты — в часовом поясе браузера."
msgstr "Количество пользователей по дате завершения миграции. Даты — в часовом поясе браузера."

#: src/containers/Services/Services.tsx:195
msgid "Количество установок ДСО"
msgstr "Количество установок ДСО"

#: src/containers/Staff/StaffForm.tsx:80
msgid "Комментарий"
msgstr "Комментарий"

#: src/containers/Services/ChangeBalance.tsx:56
msgid "Комментарий"
msgstr "Комментарий"

#: src/components/LastServiceDate/LastServiceDate.tsx:162
#: src/components/EditAuditComment/EditAuditCommentModal.tsx:86
msgid "Комментарий по желанию"
msgstr "Комментарий по желанию"

#: src/components/CommentForm/CommentForm.tsx:29
msgid "Комментарий сохранен"
msgstr "Комментарий сохранен"

#: src/components/EditAuditComment/EditAuditCommentModal.tsx:55
msgid "Комментарий успешно изменен"
msgstr "Комментарий успешно изменен"

#: src/locales/constants.ts:44
msgid "Компания"
msgstr "Компания"

#: src/containers/Migrations/Migrations.tsx:920
#: src/containers/Migrations/Migrations.tsx:2795
msgid "Конвейер миграции"
msgstr "Конвейер миграции"

#: src/containers/Migrations/Migrations.tsx:390
msgid "Конец"
msgstr "Конец"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:130
msgid "Концентрация состава"
msgstr "Концентрация состава"

#: src/features/deviceAlerts/i18n/translations.ts:14
msgid "Кончилась сдача"
msgstr "Кончилась сдача"

#: src/components/DeviceRemain.tsx:83
msgid "Корректировать остаток воды"
msgstr "Корректировать остаток воды"

#: src/containers/Services/ChangeBalance.tsx:47
msgid "Корректировка баланса:"
msgstr "Корректировка баланса:"

#: src/containers/Services/BalanceHistory.tsx:57
msgid "Кто сделал"
msgstr "Кто сделал"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:132
msgid "Купюры"
msgstr "Купюры"

#: src/locales/constants.ts:32
#: src/containers/DeviceList/columns/mobile.tsx:55
#: src/containers/DeviceList/columns/desktop.tsx:154
msgid "л"
msgstr "л"

#: src/locales/constants.ts:33
#: src/containers/DeviceList/columns/mobile.tsx:106
msgid "л/мин"
msgstr "л/мин"

#: src/containers/Sales/useSalesColumns.tsx:39
msgid "Лейбл"
msgstr "Лейбл"

#: src/containers/Migrations/Migrations.tsx:2009
msgid "Лимит параллельных подключений PostgreSQL обновлён: {value}"
msgstr "Лимит параллельных подключений PostgreSQL обновлён: {value}"

#: src/containers/Migrations/Migrations.tsx:1992
msgid "Лимит чтения DynamoDB обновлён: {value} RCU/s"
msgstr "Лимит чтения DynamoDB обновлён: {value} RCU/s"

#: src/components/Stats/constants.ts:18
msgid "Литры"
msgstr "Литры"

#: src/containers/Terminals/Terminal/Device.tsx:132
msgid "Логи"
msgstr "Логи"

#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:62
msgid "Логи билинга"
msgstr "Логи билинга"

#: src/config/menu.tsx:112
msgid "Логи пользователя"
msgstr "Логи пользователя"

#: src/locales/constants.ts:56
#: src/containers/Staff/StaffUserSelect.tsx:48
#: src/containers/Migrations/Migrations.tsx:823
#: src/containers/Login/LoginForm.tsx:74
msgid "Логин"
msgstr "Логин"

#: src/containers/Migrations/SystemMigrations.tsx:240
msgid "Локальный файл сохранён"
msgstr "Локальный файл сохранён"

#: src/containers/Migrations/formatDuration.tsx:24
msgid "м"
msgstr "м"

#: src/locales/constants.ts:39
msgid "м³"
msgstr "м³"

#: src/containers/Services/Recharge.tsx:80
msgid "Максимальная сумма платежа {maxPaymentSum}₽"
msgstr "Максимальная сумма платежа {maxPaymentSum}₽"

#: src/features/deviceAlerts/i18n/translations.ts:15
msgid "Малое количество средств на балансе SIM карты"
msgstr "Малое количество средств на балансе SIM карты"

#: src/containers/Migrations/MigrationDailyChart.tsx:58
msgid "Медианное время миграции"
msgstr "Медианное время миграции"

#: src/components/Stats/constants.ts:13
msgid "Месяц"
msgstr "Месяц"

#: src/containers/Migrations/Migrations.tsx:2752
#: src/config/menu.tsx:139
msgid "Миграции"
msgstr "Миграции"

#: src/containers/Migrations/Migrations.tsx:3135
msgid "Миграция данных"
msgstr "Миграция данных"

#: src/containers/Migrations/Migrations.tsx:2762
msgid "Миграция пользовательских данных"
msgstr "Миграция пользовательских данных"

#: src/containers/Migrations/Migrations.tsx:2140
#: src/containers/Migrations/Migrations.tsx:2218
msgid "Миграция пользователя завершена"
msgstr "Миграция пользователя завершена"

#: src/containers/Migrations/Migrations.tsx:2156
#: src/containers/Migrations/Migrations.tsx:2235
msgid "Миграция пользователя завершилась с ошибкой"
msgstr "Миграция пользователя завершилась с ошибкой"

#: src/containers/Migrations/Migrations.tsx:2166
msgid "Миграция пользователя запущена"
msgstr "Миграция пользователя запущена"

#: src/containers/Migrations/Migrations.tsx:3217
msgid "Мигрировало пользователей"
msgstr "Мигрировало пользователей"

#: src/containers/Migrations/Migrations.tsx:3563
msgid "Мигрировать только…"
msgstr "Мигрировать только…"

#: src/locales/constants.ts:35
msgid "мин"
msgstr "мин"

#: src/containers/Services/Recharge.tsx:79
msgid "Минимальна сумма платежа {minPaymentSum}₽"
msgstr "Минимальна сумма платежа {minPaymentSum}₽"

#: src/config/menu.tsx:146
msgid "Мои заказы"
msgstr "Мои заказы"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:138
msgid "Монеты"
msgstr "Монеты"

#: src/containers/Dashboard/AllMoney/utils.ts:37
msgid "Мониторинг"
msgstr "Мониторинг"

#: src/containers/Migrations/formatDuration.tsx:45
msgid "мс"
msgstr "мс"

#: src/containers/StoreOrders/StoreOrders.tsx:81
msgid "На данной вкладке отображаются ваши заказы в интернет магазине Живая Вода за последние 30 календарных дней. Обратите внимание, заказ отобразиться только в том случае, если при оформлении был указан ваш номер телефона {phone} из профиля."
msgstr "На данной вкладке отображаются ваши заказы в интернет магазине Живая Вода за последние 30 календарных дней. Обратите внимание, заказ отобразиться только в том случае, если при оформлении был указан ваш номер телефона {phone} из профиля."

#: src/containers/Services/Services.tsx:114
msgid "Нажмите на кнопку \"Пополнить баланс\" для пополнения баланса"
msgstr "Нажмите на кнопку \"Пополнить баланс\" для пополнения баланса"

#: src/components/CartridgeValue/EditValueModal.tsx:109
msgid "Нажмите ПЕРЕСЧИТАТЬ, если вы действительно поменяли счетчик ХВС на новый. Параметр ОСТАЛОСЬ ДО ЗАМЕНЫ будет пересчитан чтобы показывать корректные значения"
msgstr "Нажмите ПЕРЕСЧИТАТЬ, если вы действительно поменяли счетчик ХВС на новый. Параметр ОСТАЛОСЬ ДО ЗАМЕНЫ будет пересчитан чтобы показывать корректные значения"

#: src/containers/UserGroups/useUserGroupColumns.tsx:30
msgid "Название группы"
msgstr "Название группы"

#: src/locales/constants.ts:57
msgid "Налоговый идентификатор"
msgstr "Налоговый идентификатор"

#: src/containers/Terminals/EditDevice/MainboardFields/BottlerFields.tsx:13
msgid "Настройки бутылочника"
msgstr "Настройки бутылочника"

#: src/containers/Terminals/EditDevice/NotificationSettingsFields.tsx:22
msgid "Настройки оповещений"
msgstr "Настройки оповещений"

#: src/containers/Terminals/EditDevice/WifiFields.tsx:38
msgid "Настройки подключения по Wi-Fi"
msgstr "Настройки подключения по Wi-Fi"

#: src/containers/Migrations/SystemMigrations.tsx:72
#: src/containers/Migrations/Migrations.tsx:384
msgid "Начало"
msgstr "Начало"

#: src/containers/Migrations/SystemMigrations.tsx:299
msgid "Начать миграцию"
msgstr "Начать миграцию"

#: src/containers/Migrations/Migrations.tsx:1168
msgid "Не выполняется"
msgstr "Не выполняется"

#: src/containers/Migrations/SystemMigrations.tsx:130
msgid "Не запускалась"
msgstr "Не запускалась"

#: src/containers/Report/ReportContainer.tsx:26
msgid "Не найден корневой элемент"
msgstr "Не найден корневой элемент"

#: src/containers/Migrations/Migrations.tsx:280
#: src/containers/Migrations/Migrations.tsx:3380
msgid "Не начата"
msgstr "Не начата"

#: src/components/LastServiceDate/LastServiceDate.tsx:184
msgid "Не обслуживался"
msgstr "Не обслуживался"

#: src/containers/Services/Services.tsx:72
msgid "Не подключена"
msgstr "Не подключена"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:87
msgid "НЕ РЕКОМЕНДУЕТСЯ прошивать аппарат прошивкой tcp (это прошивки с индексом 6.00.ХХХ) Для таких аппаратов рекомендуем прошивку 4.34.37 или 4.37.67"
msgstr "НЕ РЕКОМЕНДУЕТСЯ прошивать аппарат прошивкой tcp (это прошивки с индексом 6.00.ХХХ) Для таких аппаратов рекомендуем прошивку 4.34.37 или 4.37.67"

#: src/containers/Migrations/Migrations.tsx:2622
msgid "Не удалось выполнить выборочную миграцию аппаратов"
msgstr "Не удалось выполнить выборочную миграцию аппаратов"

#: src/containers/Migrations/SystemMigrations.tsx:189
msgid "Не удалось выполнить действие. Проверьте статус и повторите попытку."
msgstr "Не удалось выполнить действие. Проверьте статус и повторите попытку."

#: src/containers/Encash/EncashComment.tsx:31
msgid "Не удалось добавить комментарий"
msgstr "Не удалось добавить комментарий"

#: src/containers/Migrations/Migrations.tsx:1966
msgid "Не удалось запустить миграцию данных"
msgstr "Не удалось запустить миграцию данных"

#: src/containers/Migrations/Migrations.tsx:2180
msgid "Не удалось запустить миграцию пользователя"
msgstr "Не удалось запустить миграцию пользователя"

#: src/containers/Migrations/Migrations.tsx:1940
msgid "Не удалось запустить оценку пользователей"
msgstr "Не удалось запустить оценку пользователей"

#: src/containers/Services/ChangeBalance.tsx:33
msgid "Не удалось изменить баланс"
msgstr "Не удалось изменить баланс"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:120
msgid "Не удалось изменить режим технических работ"
msgstr "Не удалось изменить режим технических работ"

#: src/containers/Migrations/Migrations.tsx:2576
msgid "Не удалось изменить статус миграции пользователей"
msgstr "Не удалось изменить статус миграции пользователей"

#: src/containers/Staff/StaffForm.tsx:39
msgid "Не удалось обновить данные о сотруднике"
msgstr "Не удалось обновить данные о сотруднике"

#: src/components/LastServiceDate/LastServiceDate.tsx:110
msgid "Не удалось обновить дату последнего обслуживания"
msgstr "Не удалось обновить дату последнего обслуживания"

#: src/containers/Migrations/Migrations.tsx:2016
msgid "Не удалось обновить лимит подключений PostgreSQL"
msgstr "Не удалось обновить лимит подключений PostgreSQL"

#: src/containers/Migrations/Migrations.tsx:1997
msgid "Не удалось обновить лимит чтения DynamoDB"
msgstr "Не удалось обновить лимит чтения DynamoDB"

#: src/containers/Migrations/SystemMigrations.tsx:176
msgid "Не удалось обновить статус миграции"
msgstr "Не удалось обновить статус миграции"

#: src/containers/Migrations/Migrations.tsx:1965
msgid "Не удалось остановить миграцию данных"
msgstr "Не удалось остановить миграцию данных"

#: src/containers/Migrations/Migrations.tsx:1939
msgid "Не удалось остановить оценку пользователей"
msgstr "Не удалось остановить оценку пользователей"

#: src/containers/Migrations/Migrations.tsx:3644
msgid "Не удалось получить аппараты для миграции"
msgstr "Не удалось получить аппараты для миграции"

#: src/containers/Migrations/Migrations.tsx:3710
#: src/containers/Migrations/Migrations.tsx:3995
msgid "Не удалось получить данные для визуализации"
msgstr "Не удалось получить данные для визуализации"

#: src/containers/Migrations/Migrations.tsx:3067
msgid "Не удалось получить лимит подключений PostgreSQL"
msgstr "Не удалось получить лимит подключений PostgreSQL"

#: src/containers/Migrations/Migrations.tsx:3016
msgid "Не удалось получить лимит чтения DynamoDB"
msgstr "Не удалось получить лимит чтения DynamoDB"

#: src/containers/Migrations/Migrations.tsx:3453
msgid "Не удалось получить пользователей для миграции"
msgstr "Не удалось получить пользователей для миграции"

#: src/containers/Migrations/Migrations.tsx:3203
msgid "Не удалось получить сводные показатели миграции"
msgstr "Не удалось получить сводные показатели миграции"

#: src/components/ConnectBot/ConnectMaxBot.tsx:87
#: src/components/ConnectBot/ConnectBot.tsx:88
msgid "Не удалось получить ссылку на подключение"
msgstr "Не удалось получить ссылку на подключение"

#: src/containers/Migrations/Migrations.tsx:2772
msgid "Не удалось получить статус migrator"
msgstr "Не удалось получить статус migrator"

#: src/containers/Migrations/Migrations.tsx:2251
msgid "Не удалось получить статус миграции пользователя"
msgstr "Не удалось получить статус миграции пользователя"

#: src/containers/Migrations/Migrations.tsx:2314
msgid "Не удалось получить статус расчёта"
msgstr "Не удалось получить статус расчёта"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:130
msgid "Не удалось получить статусы worker pod'ов"
msgstr "Не удалось получить статусы worker pod'ов"

#: src/containers/Sales/DeviceIncome.tsx:33
msgid "Не удалось пополнить баланс"
msgstr "Не удалось пополнить баланс"

#: src/containers/Migrations/Migrations.tsx:2091
#: src/containers/Migrations/Migrations.tsx:2101
#: src/containers/Migrations/Migrations.tsx:2300
msgid "Не удалось рассчитать метрики пользователя"
msgstr "Не удалось рассчитать метрики пользователя"

#: src/containers/Migrations/Migrations.tsx:3530
msgid "Не удалось синхронизировать аппараты"
msgstr "Не удалось синхронизировать аппараты"

#: src/containers/Migrations/Migrations.tsx:3340
msgid "Не удалось синхронизировать пользователей"
msgstr "Не удалось синхронизировать пользователей"

#: src/components/ConnectBot/ConnectMaxBot.tsx:125
#: src/components/ConnectBot/ConnectBot.tsx:133
msgid "Не удалось скопировать ссылку в буфер обмена, сделайте это вручную"
msgstr "Не удалось скопировать ссылку в буфер обмена, сделайте это вручную"

#: src/components/DeviceRemain.tsx:31
msgid "Не удалось скорректировать остаток"
msgstr "Не удалось скорректировать остаток"

#: src/containers/Terminals/NewDevice/NewDevice.tsx:59
msgid "Не удалось создать аппарат"
msgstr "Не удалось создать аппарат"

#: src/components/CommentForm/CommentForm.tsx:33
msgid "Не удалось сохранить комментарий"
msgstr "Не удалось сохранить комментарий"

#: src/containers/Migrations/SystemMigrations.tsx:235
msgid "Не удалось сохранить файл в MinIO"
msgstr "Не удалось сохранить файл в MinIO"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:321
msgid "Не удалось сравнить состояния аппарата"
msgstr "Не удалось сравнить состояния аппарата"

#: src/containers/Migrations/Migrations.tsx:2659
msgid "Не удалось сравнить состояния аппаратов"
msgstr "Не удалось сравнить состояния аппаратов"

#: src/containers/Staff/StaffForm.tsx:60
msgid "Не удалось удалить данные о сотруднике"
msgstr "Не удалось удалить данные о сотруднике"

#: src/containers/Users/UserMenu.tsx:105
msgid "Не удалось удалить пользователя"
msgstr "Не удалось удалить пользователя"

#: src/components/LastServiceDate/LastServiceDate.tsx:79
msgid "Не указана дата обслуживания"
msgstr "Не указана дата обслуживания"

#: src/containers/Users/NewUser.tsx:46
msgid "Неверный формат"
msgstr "Неверный формат"

#: src/components/Stats/constants.ts:12
msgid "Неделя"
msgstr "Неделя"

#: src/containers/Services/Services.tsx:62
msgid "Недостаточно денежных средств для подключения данной услуги"
msgstr "Недостаточно денежных средств для подключения данной услуги"

#: src/containers/Terminals/BlockedByService/BlockedByService.tsx:5
msgid "Недостаточно средств для отображения списка устройств"
msgstr "Недостаточно средств для отображения списка устройств"

#: src/ui-kit/Form/Switch/Switch.tsx:139
#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:113
#: src/components/Switch.tsx:81
msgid "Нет"
msgstr "Нет"

#: src/containers/Migrations/Migrations.tsx:1270
msgid "Нет активной операции"
msgstr "Нет активной операции"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:181
msgid "Нет аппаратов с таким адресом"
msgstr "Нет аппаратов с таким адресом"

#: src/ui-kit/Table/Table.tsx:234
msgid "Нет данных"
msgstr "Нет данных"

#: src/containers/Migrations/Migrations.tsx:3773
msgid "Нет данных для визуализации"
msgstr "Нет данных для визуализации"

#: src/containers/Migrations/MigrationDailyChart.tsx:114
msgid "Нет завершённых миграций"
msgstr "Нет завершённых миграций"

#: src/features/deviceAlerts/i18n/translations.ts:13
msgid "Нет платежей по каналу безналичная оплата (оплата банковской картой) более 2x часов"
msgstr "Нет платежей по каналу безналичная оплата (оплата банковской картой) более 2x часов"

#: src/containers/Migrations/Migrations.tsx:3987
msgid "Нет рассчитанных пользователей для рейтинга"
msgstr "Нет рассчитанных пользователей для рейтинга"

#: src/containers/Migrations/SystemMigrations.tsx:126
msgid "Нет связи"
msgstr "Нет связи"

#: src/containers/Terminals/EditDevice/EditDeviceTabs.tsx:97
msgid "Нет связи с платой водоподготовки"
msgstr "Нет связи с платой водоподготовки"

#: src/containers/Terminals/EditDevice/EditDeviceTabs.tsx:82
msgid "Нет связи с платой управления"
msgstr "Нет связи с платой управления"

#: src/containers/Services/ChangeBalance.tsx:51
msgid "Новый баланс"
msgstr "Новый баланс"

#: src/containers/Login/LoginForm.tsx:100
msgid "Новый пароль"
msgstr "Новый пароль"

#: src/containers/Dashboard/AllMoney/utils.ts:65
msgid "Новых устройств за период"
msgstr "Новых устройств за период"

#: src/containers/Dashboard/AllMoney/utils.ts:73
msgid "Новых устройств: оплачен App/QR"
msgstr "Новых устройств: оплачен App/QR"

#: src/containers/Dashboard/AllMoney/utils.ts:69
msgid "Новых устройств: оплачен мониторинг"
msgstr "Новых устройств: оплачен мониторинг"

#: src/containers/Dashboard/AllMoney/utils.ts:77
msgid "Новых устройств: оплачен мониторинг + App/QR"
msgstr "Новых устройств: оплачен мониторинг + App/QR"

#: src/locales/constants.ts:15
msgid "Номер SIM"
msgstr "Номер SIM"

#: src/containers/Terminals/Terminal/DeviceState/TerminalBoard.tsx:112
msgid "Номер Техподдержки"
msgstr "Номер Техподдержки"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:72
msgid "Номер Техподдержки в 1 строке"
msgstr "Номер Техподдержки в 1 строке"

#: src/containers/Migrations/Migrations.tsx:281
msgid "Нужен частичный пересчёт"
msgstr "Нужен частичный пересчёт"

#: src/containers/Migrations/Migrations.tsx:2986
msgid "Обновить"
msgstr "Обновить"

#: src/containers/Migrations/Migrations.tsx:2645
msgid "Обновлена схожесть аппаратов: {comparedCount}"
msgstr "Обновлена схожесть аппаратов: {comparedCount}"

#: src/containers/Migrations/Migrations.tsx:1231
msgid "Обновление progress.txt"
msgstr "Обновление progress.txt"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:120
msgid "Оборудование"
msgstr "Оборудование"

#: src/containers/Dashboard/BillingStats/columns.tsx:68
msgid "Обработано с ошибкой"
msgstr "Обработано с ошибкой"

#: src/containers/Terminals/EditDevice/PromoField.tsx:11
msgid "Обратите внимание, для корректной работы режима Промоакция параметр Автостоп наличные/банк.карта установлен равным 5 литров"
msgstr "Обратите внимание, для корректной работы режима Промоакция параметр Автостоп наличные/банк.карта установлен равным 5 литров"

#: src/components/BYNotification.tsx:26
msgid "Обращаем ваше внимание, что с 14.07.2026 для вендоров из Республики Беларусь техническая поддержка осуществляется ТОЛЬКО силами специалистов компании Живая Вода Россия. Телеграмм чат технической поддержки<0>@alivewaternewbot</0>"
msgstr "Обращаем ваше внимание, что с 14.07.2026 для вендоров из Республики Беларусь техническая поддержка осуществляется ТОЛЬКО силами специалистов компании Живая Вода Россия. Телеграмм чат технической поддержки<0>@alivewaternewbot</0>"

#: src/containers/DeviceList/columns/list.tsx:84
#: src/containers/DeviceList/columns/desktop.tsx:220
msgid "Обслуживание"
msgstr "Обслуживание"

#: src/containers/Dashboard/Users/Users.tsx:47
msgid "Общая статистика"
msgstr "Общая статистика"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:62
msgid "Общее"
msgstr "Общее"

#: src/containers/Migrations/Migrations.tsx:3845
msgid "Общий объём"
msgstr "Общий объём"

#: src/containers/Services/Recharge.tsx:78
msgid "Обязательное поле"
msgstr "Обязательное поле"

#: src/containers/Migrations/Migrations.tsx:3057
msgid "Ограничение записи PostgreSQL"
msgstr "Ограничение записи PostgreSQL"

#: src/containers/Migrations/Migrations.tsx:3006
msgid "Ограничение чтения DynamoDB"
msgstr "Ограничение чтения DynamoDB"

#: src/containers/Migrations/SystemMigrations.tsx:102
#: src/containers/Migrations/Migrations.tsx:264
#: src/containers/Migrations/Migrations.tsx:282
msgid "Ожидает"
msgstr "Ожидает"

#: src/containers/Migrations/Migrations.tsx:2784
msgid "Ожидает запуска"
msgstr "Ожидает запуска"

#: src/containers/Migrations/Migrations.tsx:2972
msgid "Ожидают блокировки"
msgstr "Ожидают блокировки"

#: src/containers/Dashboard/Geography/Geography.tsx:26
msgid "Округа: {districtCount}"
msgstr "Округа: {districtCount}"

#: src/config/menu.tsx:118
msgid "ОМНИДЕСК-сообщения"
msgstr "ОМНИДЕСК-сообщения"

#: src/containers/UserInfo/UserInfo.tsx:68
#: src/containers/Omnidesk/OmnuUser.tsx:20
msgid "Онлайн"
msgstr "Онлайн"

#: src/containers/UserGroups/useUserGroupColumns.tsx:49
msgid "Описание"
msgstr "Описание"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:145
msgid "Оплата через приложение"
msgstr "Оплата через приложение"

#: src/containers/Dashboard/Devices/utils.ts:64
msgid "Оплаченных"
msgstr "Оплаченных"

#: src/containers/LowBalanceNotification/LowBalanceNotification.tsx:41
msgid "Оплачу позже"
msgstr "Оплачу позже"

#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:24
msgid "Оповещения"
msgstr "Оповещения"

#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:21
msgid "Основные настройки"
msgstr "Основные настройки"

#: src/containers/Migrations/Migrations.tsx:3283
msgid "Осталось на миграцию, чч:мм:сс (прогноз ≈)"
msgstr "Осталось на миграцию, чч:мм:сс (прогноз ≈)"

#: src/containers/Migrations/Migrations.tsx:3259
msgid "Осталось на оценку, чч:мм:сс (прогноз)"
msgstr "Осталось на оценку, чч:мм:сс (прогноз)"

#: src/containers/Migrations/SystemMigrations.tsx:128
#: src/containers/Migrations/Migrations.tsx:1173
msgid "Останавливается"
msgstr "Останавливается"

#: src/containers/Migrations/Migrations.tsx:1184
msgid "Останавливается после пользователя"
msgstr "Останавливается после пользователя"

#: src/containers/Migrations/Migrations.tsx:1323
#: src/containers/Migrations/Migrations.tsx:1333
msgid "Останавливается…"
msgstr "Останавливается…"

#: src/containers/Migrations/SystemMigrations.tsx:290
#: src/containers/Migrations/Migrations.tsx:1334
msgid "Остановить миграцию"
msgstr "Остановить миграцию"

#: src/containers/Migrations/Migrations.tsx:1324
msgid "Остановить оценку"
msgstr "Остановить оценку"

#: src/containers/Migrations/SystemMigrations.tsx:306
msgid "Остановка выполняется после текущей страницы или пакета. Уже перенесённые ключи остаются в Redis; готовый файл сохраняется в MinIO."
msgstr "Остановка выполняется после текущей страницы или пакета. Уже перенесённые ключи остаются в Redis; готовый файл сохраняется в MinIO."

#: src/containers/Migrations/SystemMigrations.tsx:137
msgid "Остановка запрошена. Ожидаем завершения текущего пакета и сохранения готового файла."
msgstr "Остановка запрошена. Ожидаем завершения текущего пакета и сохранения готового файла."

#: src/containers/Migrations/Migrations.tsx:3152
msgid "Остановка оценки завершает текущего пользователя и не начинает следующего. Остановка миграции работает так же: текущий пользователь завершается полностью."
msgstr "Остановка оценки завершает текущего пользователя и не начинает следующего. Остановка миграции работает так же: текущий пользователь завершается полностью."

#: src/containers/Migrations/SystemMigrations.tsx:45
#: src/containers/Migrations/SystemMigrations.tsx:107
msgid "Остановлена"
msgstr "Остановлена"

#: src/components/DeviceRemain.tsx:45
msgid "Остаток"
msgstr "Остаток"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:172
msgid "Остаток воды"
msgstr "Остаток воды"

#: src/components/DeviceRemain.tsx:27
msgid "Остаток скорректирован"
msgstr "Остаток скорректирован"

#: src/containers/DeviceList/columns/desktop.tsx:70
msgid "Остаток тары"
msgstr "Остаток тары"

#: src/containers/Migrations/Migrations.tsx:1084
msgid "Открывает аппарат пользователя в Alivewater Cloud"
msgstr "Открывает аппарат пользователя в Alivewater Cloud"

#: src/containers/Migrations/Migrations.tsx:1098
msgid "Открывает вкладку аппаратов с фильтром по этому пользователю"
msgstr "Открывает вкладку аппаратов с фильтром по этому пользователю"

#: src/containers/Migrations/Migrations.tsx:1106
msgid "Открывает список аппаратов пользователя в Alivewater Cloud"
msgstr "Открывает список аппаратов пользователя в Alivewater Cloud"

#: src/containers/Migrations/Migrations.tsx:1082
msgid "Открыть аппарат на production-площадке"
msgstr "Открыть аппарат на production-площадке"

#: src/containers/Migrations/Migrations.tsx:1104
msgid "Открыть на production-площадке"
msgstr "Открыть на production-площадке"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:88
msgid "Отмена"
msgstr "Отмена"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:112
#: src/containers/Staff/StaffForm.tsx:94
#: src/containers/Services/Recharge.tsx:125
msgid "Отменить"
msgstr "Отменить"

#: src/containers/Migrations/Migrations.tsx:3937
msgid "Относительно лидера"
msgstr "Относительно лидера"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:338
msgid "Отсутствует в PostgreSQL"
msgstr "Отсутствует в PostgreSQL"

#: src/locales/constants.ts:51
msgid "Отчество"
msgstr "Отчество"

#. placeholder {0}: date ? t`за ${DateTime.fromMillis(Number(date)) .setLocale('ru-ru') .toFormat('dd-MM-yyyy')}` : null
#: src/containers/Report/Report.tsx:52
msgid "Отчет {user} {0}"
msgstr "Отчет {user} {0}"

#: src/containers/Dashboard/Devices/Devices.tsx:32
#: src/containers/Dashboard/AllMoney/AllMoney.tsx:71
msgid "Отчетный период:"
msgstr "Отчетный период:"

#: src/containers/StoreOrders/StoreOrders.tsx:71
msgid "Оформить заказ в интернет магазине"
msgstr "Оформить заказ в интернет магазине"

#: src/containers/Users/UsersList.tsx:32
#: src/containers/UserInfo/UserInfo.tsx:68
#: src/containers/Omnidesk/OmnuUser.tsx:20
msgid "Оффлайн"
msgstr "Оффлайн"

#: src/containers/Migrations/Migrations.tsx:3120
msgid "Оценка пользователей"
msgstr "Оценка пользователей"

#: src/containers/Migrations/Migrations.tsx:2064
msgid "Оценка пользователя завершена"
msgstr "Оценка пользователя завершена"

#: src/containers/Migrations/Migrations.tsx:2884
msgid "Очередь Query"
msgstr "Очередь Query"

#: src/containers/Migrations/Migrations.tsx:3095
msgid "Очередь порций"
msgstr "Очередь порций"

#: src/containers/Migrations/SystemMigrations.tsx:43
#: src/containers/Migrations/SystemMigrations.tsx:105
#: src/containers/Migrations/Migrations.tsx:268
#: src/containers/Migrations/Migrations.tsx:285
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:24
msgid "Ошибка"
msgstr "Ошибка"

#: src/contexts/UserContext/UserContext.tsx:72
msgid "Ошибка авторизации"
msgstr "Ошибка авторизации"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:130
msgid "Ошибка активации аппарата"
msgstr "Ошибка активации аппарата"

#: src/containers/Login/LoginForm.tsx:54
msgid "Ошибка восстановления пароля"
msgstr "Ошибка восстановления пароля"

#: src/contexts/UserContext/UserContext.tsx:277
msgid "Ошибка входа"
msgstr "Ошибка входа"

#: src/containers/Migrations/SystemMigrations.tsx:220
msgid "Ошибка выгрузки"
msgstr "Ошибка выгрузки"

#: src/containers/Terminals/Terminal/ResetDevice.tsx:31
msgid "Ошибка выполнения операции"
msgstr "Ошибка выполнения операции"

#: src/containers/Migrations/SystemMigrations.tsx:225
msgid "Ошибка записи в Redis"
msgstr "Ошибка записи в Redis"

#: src/features/deviceAlerts/i18n/translations.ts:18
msgid "Ошибка купюроприемника"
msgstr "Ошибка купюроприемника"

#: src/containers/Migrations/Migrations.tsx:743
#: src/containers/Migrations/Migrations.tsx:1039
msgid "Ошибка миграции"
msgstr "Ошибка миграции"

#: src/features/deviceAlerts/i18n/translations.ts:19
msgid "Ошибка монетоприемника"
msgstr "Ошибка монетоприемника"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:90
msgid "Ошибка операции"
msgstr "Ошибка операции"

#: src/containers/Migrations/Migrations.tsx:725
#: src/containers/Migrations/Migrations.tsx:1020
msgid "Ошибка оценки"
msgstr "Ошибка оценки"

#: src/containers/StoreOrders/StoreOrders.tsx:56
msgid "Ошибка получения заказов"
msgstr "Ошибка получения заказов"

#: src/contexts/UserContext/UserContext.tsx:306
msgid "Ошибка сброса пароля"
msgstr "Ошибка сброса пароля"

#: src/containers/Migrations/SystemMigrations.tsx:215
msgid "Ошибка сохранения состояния в PostgreSQL"
msgstr "Ошибка сохранения состояния в PostgreSQL"

#: src/features/deviceAlerts/i18n/translations.ts:17
msgid "Ошибка фискального сервера"
msgstr "Ошибка фискального сервера"

#: src/containers/Migrations/Migrations.tsx:2838
msgid "Память pod: свободно / всего"
msgstr "Память pod: свободно / всего"

#: src/containers/Migrations/Migrations.tsx:2756
msgid "Панель управления миграцией"
msgstr "Панель управления миграцией"

#: src/containers/Migrations/Migrations.tsx:3071
msgid "Параллельные подключения COPY"
msgstr "Параллельные подключения COPY"

#: src/locales/constants.ts:52
#: src/containers/Terminals/EditDevice/WifiFields.tsx:54
#: src/containers/Login/LoginForm.tsx:86
msgid "Пароль"
msgstr "Пароль"

#: src/containers/Users/UserMenu.tsx:143
msgid "Пароль пользователя<0>{Username}</0>будет сброшен. На адрес {Email} будет отправлен код восстановления."
msgstr "Пароль пользователя<0>{Username}</0>будет сброшен. На адрес {Email} будет отправлен код восстановления."

#: src/locales/constants.ts:60
msgid "Перевод отсутствует"
msgstr "Перевод отсутствует"

#: src/containers/Terminals/Terminal/ResetDevice.tsx:40
msgid "Перезагрузить плату управления"
msgstr "Перезагрузить плату управления"

#: src/containers/LowBalanceNotification/LowBalanceNotification.tsx:40
msgid "Перейти к оплате"
msgstr "Перейти к оплате"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:107
msgid "Перейти на редактирование вторичного устройства"
msgstr "Перейти на редактирование вторичного устройства"

#: src/containers/Migrations/Migrations.tsx:1073
msgid "Перенести данные пользователя"
msgstr "Перенести данные пользователя"

#: src/containers/Migrations/SystemMigrations.tsx:169
msgid "Перенос общих данных, не привязанных к пользователям и аппаратам."
msgstr "Перенос общих данных, не привязанных к пользователям и аппаратам."

#: src/components/CartridgeValue/EditValueModal.tsx:106
msgid "Пересчитать"
msgstr "Пересчитать"

#: src/components/CartridgeValue/EditValueModal.tsx:105
msgid "Пересчитать ресурс фильтров?"
msgstr "Пересчитать ресурс фильтров?"

#: src/containers/Sales/Sales.tsx:133
#: src/containers/Encash/Encash.tsx:88
#: src/components/Stats/Stats.tsx:144
msgid "Период"
msgstr "Период"

#: src/containers/Services/BalanceHistory.tsx:110
msgid "Период:"
msgstr "Период:"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:154
msgid "Периодичность запуска промывки ХВС {pflUnit}"
msgstr "Периодичность запуска промывки ХВС {pflUnit}"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:123
msgid "Периодичность промывки"
msgstr "Периодичность промывки"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:82
#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:22
msgid "Плата управления"
msgstr "Плата управления"

#: src/containers/Terminals/Terminal/ResetDevice.tsx:26
msgid "Плата управления будет перезагружена"
msgstr "Плата управления будет перезагружена"

#: src/containers/Dashboard/AllMoney/utils.ts:9
msgid "Платежи от ckassa"
msgstr "Платежи от ckassa"

#: src/containers/Dashboard/AllMoney/utils.ts:14
msgid "Платежными поручениями"
msgstr "Платежными поручениями"

#: src/containers/DeviceList/constants.ts:15
msgid "по адресу"
msgstr "по адресу"

#: src/containers/DeviceList/AuditTab/AuditTab.tsx:215
msgid "по адресу аппарата"
msgstr "по адресу аппарата"

#: src/containers/DeviceList/constants.ts:14
msgid "по дате первого запуска"
msgstr "по дате первого запуска"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:39
msgid "По закату и рассвету (только Россия)"
msgstr "По закату и рассвету (только Россия)"

#: src/containers/Migrations/Migrations.tsx:3694
msgid "По оси X — количество аппаратов у пользователя, по оси Y — количество пользователей."
msgstr "По оси X — количество аппаратов у пользователя, по оси Y — количество пользователей."

#: src/containers/DeviceList/constants.ts:19
msgid "по предупреждениям"
msgstr "по предупреждениям"

#: src/containers/DeviceList/constants.ts:16
msgid "по примечанию"
msgstr "по примечанию"

#: src/containers/Terminals/EditDevice/DeviceAdditionalFields.tsx:32
msgid "По расписанию"
msgstr "По расписанию"

#: src/containers/DeviceList/constants.ts:17
msgid "по сумме всего"
msgstr "по сумме всего"

#: src/containers/DeviceList/constants.ts:18
msgid "по сумме за день"
msgstr "по сумме за день"

#: src/containers/Migrations/SystemMigrations.tsx:179
msgid "Повторить"
msgstr "Повторить"

#: src/containers/Migrations/Migrations.tsx:1213
msgid "Подготовка временного каталога"
msgstr "Подготовка временного каталога"

#: src/containers/Migrations/Migrations.tsx:1211
msgid "Подготовка списка аппаратов"
msgstr "Подготовка списка аппаратов"

#: src/containers/Services/Services.tsx:68
msgid "Подключена"
msgstr "Подключена"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:149
msgid "Подсветка"
msgstr "Подсветка"

#: src/containers/DeviceList/DeviceList.tsx:309
msgid "Подсветка оповещений"
msgstr "Подсветка оповещений"

#: src/containers/Dashboard/Users/Users.tsx:79
msgid "Подтвержденных"
msgstr "Подтвержденных"

#: src/containers/Dashboard/Users/Users.tsx:53
msgid "Подтвержденных:"
msgstr "Подтвержденных:"

#: src/containers/SystemMaintenance/MaintenancePage.tsx:16
msgid "Пожалуйста, попробуйте выполнить операцию позже."
msgstr "Пожалуйста, попробуйте выполнить операцию позже."

#: src/containers/Migrations/Migrations.tsx:3618
msgid "Поиск по Device ID или User ID"
msgstr "Поиск по Device ID или User ID"

#: src/containers/Migrations/Migrations.tsx:3418
msgid "Поиск по логину или User ID"
msgstr "Поиск по логину или User ID"

#: src/containers/DeviceList/columns/desktop.tsx:119
msgid "Показания"
msgstr "Показания"

#: src/containers/Migrations/Migrations.tsx:3397
msgid "Показать аппараты выбранных пользователей"
msgstr "Показать аппараты выбранных пользователей"

#: src/containers/Migrations/Migrations.tsx:1096
msgid "Показать аппараты пользователя"
msgstr "Показать аппараты пользователя"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:151
msgid "Показать данные без форматирования"
msgstr "Показать данные без форматирования"

#: src/containers/Migrations/Migrations.tsx:1190
msgid "Показать пользователя в таблице"
msgstr "Показать пользователя в таблице"

#: src/containers/Migrations/Migrations.tsx:3434
msgid "Показать удаленных"
msgstr "Показать удаленных"

#: src/containers/Migrations/Migrations.tsx:1090
msgid "Показывает различия между состояниями аппарата в DynamoDB и PostgreSQL"
msgstr "Показывает различия между состояниями аппарата в DynamoDB и PostgreSQL"

#: src/components/ui/Pagination.tsx:56
msgid "Показывать{limitsSelect}записей"
msgstr "Показывать{limitsSelect}записей"

#: src/locales/constants.ts:17
msgid "Поле примечание выводится в 5 строке экрана \"Аппараты\" в столбце Адрес. В этом поле вы можете указать дополнительную информацию к адресу установки. По этому полю так же возможно отсортировать аппараты."
msgstr "Поле примечание выводится в 5 строке экрана \"Аппараты\" в столбце Адрес. В этом поле вы можете указать дополнительную информацию к адресу установки. По этому полю так же возможно отсортировать аппараты."

#: src/containers/Migrations/Migrations.tsx:1069
msgid "Получает количество данных пользователя из DynamoDB"
msgstr "Получает количество данных пользователя из DynamoDB"

#: src/containers/Migrations/Migrations.tsx:3760
#: src/containers/Migrations/MigrationDailyChart.tsx:51
#: src/containers/Migrations/MigrationDailyChart.tsx:107
msgid "Пользователей"
msgstr "Пользователей"

#: src/containers/Migrations/Migrations.tsx:3221
msgid "Пользователей с рассчитанными метриками"
msgstr "Пользователей с рассчитанными метриками"

#: src/containers/Users/Users.tsx:25
#: src/containers/Migrations/Migrations.tsx:3313
#: src/containers/Dashboard/Dashboard.tsx:34
#: src/config/menu.tsx:42
msgid "Пользователи"
msgstr "Пользователи"

#: src/containers/Migrations/Migrations.tsx:3896
msgid "Пользователи с наибольшим количеством продаж или записей телеметрии."
msgstr "Пользователи с наибольшим количеством продаж или записей телеметрии."

#: src/containers/Migrations/Migrations.tsx:3921
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:19
msgid "Пользователь"
msgstr "Пользователь"

#: src/containers/Users/UserMenu.tsx:168
msgid "Пользователь <0>{Username}</0> будет заблокирован. Он не сможет авторизоваться в личном кабинете."
msgstr "Пользователь <0>{Username}</0> будет заблокирован. Он не сможет авторизоваться в личном кабинете."

#: src/containers/Users/UserMenu.tsx:119
msgid "Пользователь <0>{Username}</0> будет удален безвозвратно."
msgstr "Пользователь <0>{Username}</0> будет удален безвозвратно."

#: src/components/ConnectBot/ConnectMaxBot.tsx:170
msgid "Пользователь Max успешно отвязан"
msgstr "Пользователь Max успешно отвязан"

#: src/containers/Users/UserMenu.tsx:91
msgid "Пользователь заблокирован"
msgstr "Пользователь заблокирован"

#: src/containers/Users/UserMenu.tsx:92
msgid "Пользователь разблокирован"
msgstr "Пользователь разблокирован"

#: src/containers/Users/NewUser.tsx:73
msgid "Пользователь создан. Данные отправлены на {Email}"
msgstr "Пользователь создан. Данные отправлены на {Email}"

#: src/containers/Users/UserMenu.tsx:103
msgid "Пользователь удален"
msgstr "Пользователь удален"

#: src/containers/Migrations/Migrations.tsx:826
msgid "Пользователь удалён из DynamoDB"
msgstr "Пользователь удалён из DynamoDB"

#: src/containers/Users/NewUser.tsx:79
msgid "Пользователь уже существует"
msgstr "Пользователь уже существует"

#: src/containers/UserInfo/UserInfo.tsx:71
msgid "Пользователь:"
msgstr "Пользователь:"

#: src/containers/Terminals/EditDevice/BundleDeviceInfo.tsx:25
#: src/components/ServiceNotificationModal.tsx:33
msgid "Понятно"
msgstr "Понятно"

#: src/containers/Services/Recharge.tsx:124
#: src/containers/Sales/DeviceIncome.tsx:59
msgid "Пополнить"
msgstr "Пополнить"

#: src/containers/Services/Recharge.tsx:118
#: src/containers/Services/Recharge.tsx:121
#: src/containers/Sales/DeviceIncome.tsx:90
msgid "Пополнить баланс"
msgstr "Пополнить баланс"

#: src/containers/Sales/DeviceIncome.tsx:86
msgid "Пополнить баланс клиенту на аппарате"
msgstr "Пополнить баланс клиенту на аппарате"

#: src/containers/UserInfo/UserInfo.tsx:78
msgid "Последний визит:"
msgstr "Последний визит:"

#: src/locales/constants.ts:50
msgid "Последний вход"
msgstr "Последний вход"

#: src/containers/DeviceList/columns/mobile.tsx:309
#: src/containers/DeviceList/columns/desktop.tsx:168
msgid "Последний выход на связь"
msgstr "Последний выход на связь"

#: src/containers/Migrations/Migrations.tsx:3581
msgid "Последнюю инкассацию"
msgstr "Последнюю инкассацию"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:94
#: src/containers/Migrations/Migrations.tsx:2603
msgid "Последняя инкассация"
msgstr "Последняя инкассация"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:110
#: src/containers/DeviceList/columns/mobile.tsx:324
#: src/containers/DeviceList/columns/desktop.tsx:183
msgid "Последняя продажа"
msgstr "Последняя продажа"

#: src/containers/Sales/useSalesColumns.tsx:123
msgid "Потенциально фишинговая продажа"
msgstr "Потенциально фишинговая продажа"

#: src/features/deviceAlerts/components/DeviceAlerts.tsx:31
msgid "Предупреждений не обнаружено"
msgstr "Предупреждений не обнаружено"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:98
#: src/containers/DeviceList/columns/base.tsx:20
msgid "Предупреждения"
msgstr "Предупреждения"

#: src/containers/Migrations/Migrations.tsx:749
msgid "Предыдущий User ID"
msgstr "Предыдущий User ID"

#: src/containers/Migrations/SystemMigrations.tsx:44
msgid "Прервано"
msgstr "Прервано"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:91
#: src/containers/DeviceList/constants.ts:25
msgid "Приборы"
msgstr "Приборы"

#: src/containers/Services/PaymentType.tsx:71
msgid "Прием платежей временно не доступен. Обратитесь в техническую поддержку в телеграмм @alivewaternewbot"
msgstr "Прием платежей временно не доступен. Обратитесь в техническую поддержку в телеграмм @alivewaternewbot"

#: src/locales/constants.ts:16
#: src/containers/DeviceList/columns/list.tsx:115
msgid "Примечание"
msgstr "Примечание"

#: src/containers/Dashboard/BillingStats/columns.tsx:47
msgid "Прогноз завершения"
msgstr "Прогноз завершения"

#: src/features/salesDynamics/ui/SalesDynamicsTotal.tsx:48
#: src/containers/DeviceList/columns/salesDynamicsColumns.tsx:23
msgid "Прогноз на {month}"
msgstr "Прогноз на {month}"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:176
msgid "Прогноз остатка на конец текущих суток"
msgstr "Прогноз остатка на конец текущих суток"

#: src/containers/Migrations/Migrations.tsx:3286
msgid "Прогноз рассчитан по сумме времени обработки пользователей. Этапы конвейера выполняются параллельно, поэтому фактическое оставшееся календарное время может быть меньше прогноза."
msgstr "Прогноз рассчитан по сумме времени обработки пользователей. Этапы конвейера выполняются параллельно, поэтому фактическое оставшееся календарное время может быть меньше прогноза."

#: src/containers/Dashboard/BillingStats/columns.tsx:42
msgid "Прогресс"
msgstr "Прогресс"

#: src/containers/Migrations/Migrations.tsx:3931
msgid "Продаж"
msgstr "Продаж"

#: src/containers/Terminals/Terminal/Device.tsx:98
#: src/containers/Migrations/Migrations.tsx:649
#: src/containers/Migrations/Migrations.tsx:936
#: src/containers/Migrations/Migrations.tsx:3817
#: src/containers/Migrations/Migrations.tsx:3905
#: src/config/menu.tsx:61
msgid "Продажи"
msgstr "Продажи"

#: src/containers/Migrations/Migrations.tsx:3784
msgid "Продажи, инкассации и события учитываются полностью. В альтернативных сценариях уменьшается только объединённая телеметрия."
msgstr "Продажи, инкассации и события учитываются полностью. В альтернативных сценариях уменьшается только объединённая телеметрия."

#: src/containers/Migrations/Migrations.tsx:396
#: src/containers/Dashboard/BillingStats/columns.tsx:52
msgid "Продолжительность"
msgstr "Продолжительность"

#: src/containers/Users/UserMenu.tsx:125
#: src/containers/Users/UserMenu.tsx:151
#: src/containers/Users/UserMenu.tsx:174
msgid "Продолжить?"
msgstr "Продолжить?"

#: src/config/menu.tsx:106
msgid "Проект Оракул"
msgstr "Проект Оракул"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:18
msgid "Промывка ежедневно"
msgstr "Промывка ежедневно"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:14
msgid "Промывка отключена"
msgstr "Промывка отключена"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:26
msgid "Промывка через два дня"
msgstr "Промывка через два дня"

#: src/containers/Terminals/EditDevice/AcidWashFields.tsx:22
msgid "Промывка через день"
msgstr "Промывка через день"

#: src/containers/Migrations/SystemMigrations.tsx:106
msgid "Пропущен"
msgstr "Пропущен"

#: src/containers/Migrations/Migrations.tsx:2567
msgid "Пропущено выполняющихся миграций: {skippedCount}"
msgstr "Пропущено выполняющихся миграций: {skippedCount}"

#: src/containers/Migrations/SystemMigrations.tsx:210
msgid "Пропущено истёкших"
msgstr "Пропущено истёкших"

#: src/containers/UserInfo/UserInfo.tsx:94
#: src/containers/Profile/EditProfile.tsx:62
msgid "Профиль"
msgstr "Профиль"

#: src/containers/Profile/EditProfile.tsx:53
msgid "Профиль обновлен"
msgstr "Профиль обновлен"

#: src/containers/Sales/SalesTotal.tsx:137
msgid "Процент конвертации (за текущие сутки): {conversion}"
msgstr "Процент конвертации (за текущие сутки): {conversion}"

#: src/config/menu.tsx:88
msgid "Прошивка оборудования"
msgstr "Прошивка оборудования"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:71
msgid "Прошивка платы управления"
msgstr "Прошивка платы управления"

#: src/containers/Users/UserMenu.tsx:215
msgid "Разблокировать"
msgstr "Разблокировать"

#: src/containers/Migrations/Migrations.tsx:2889
msgid "Размер страницы Query"
msgstr "Размер страницы Query"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:347
msgid "Разница"
msgstr "Разница"

#: src/containers/OraclePage/ComputeTab/utils.ts:110
msgid "Разовые расходы в выбранный период отсутствуют"
msgstr "Разовые расходы в выбранный период отсутствуют"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:164
msgid "Разрешить водоподготовку"
msgstr "Разрешить водоподготовку"

#: src/locales/constants.ts:20
msgid "Разрешить продажу минеральной воды"
msgstr "Разрешить продажу минеральной воды"

#: src/containers/Terminals/Terminal/Device.tsx:109
msgid "Расписание"
msgstr "Расписание"

#: src/containers/Migrations/Migrations.tsx:3689
msgid "Распределение пользователей по количеству аппаратов"
msgstr "Распределение пользователей по количеству аппаратов"

#: src/containers/Migrations/Migrations.tsx:1067
msgid "Рассчитать метрики пользователя"
msgstr "Рассчитать метрики пользователя"

#: src/containers/Migrations/Migrations.tsx:3596
msgid "Рассчитать схожесть"
msgstr "Рассчитать схожесть"

#: src/containers/Services/Services.tsx:209
#: src/containers/DeviceList/columns/mobile.tsx:358
#: src/containers/DeviceList/columns/desktop.tsx:206
msgid "Расход"
msgstr "Расход"

#. placeholder {0}: convertTimestampToLocalDateString( data.period.fromTs )
#. placeholder {1}: convertTimestampToLocalDateString( data.period.toTs )
#: src/containers/OraclePage/ComputeTab/utils.ts:228
msgid "Расходы для терминала были посчитаны за период с {0} по {1} (когда были продажи)."
msgstr "Расходы для терминала были посчитаны за период с {0} по {1} (когда были продажи)."

#: src/containers/Dashboard/Geography/Geography.tsx:30
msgid "Регионы: {regionCount}"
msgstr "Регионы: {regionCount}"

#: src/containers/Terminals/EditDevice/EditDevice.tsx:158
msgid "Редактирование аппарата"
msgstr "Редактирование аппарата"

#: src/containers/Encash/EncashComment.tsx:49
msgid "Редактирование комментария"
msgstr "Редактирование комментария"

#: src/containers/Users/UserMenu.tsx:204
#: src/containers/Staff/StaffForm.tsx:84
msgid "Редактировать"
msgstr "Редактировать"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:160
msgid "Режим “Промоакция”"
msgstr "Режим “Промоакция”"

#: src/components/CartridgeValue/EditValueModal.tsx:91
msgid "Ресурс фильтров успешно обновлен"
msgstr "Ресурс фильтров успешно обновлен"

#: src/locales/constants.ts:54
msgid "Роль"
msgstr "Роль"

#: src/containers/Dashboard/AllMoney/utils.ts:24
msgid "Ручная корректировка"
msgstr "Ручная корректировка"

#: src/containers/Dashboard/AllMoney/utils.ts:47
msgid "Ручные корректировки"
msgstr "Ручные корректировки"

#: src/containers/Migrations/formatDuration.tsx:30
#: src/containers/Migrations/MigrationDailyChart.tsx:23
#: src/containers/Migrations/DeviceStateComparisonModal.tsx:388
msgid "с"
msgstr "с"

#: src/features/serviceNotification/ServiceNotification.tsx:26
msgid "С 22:00 13 октября (МСК) по 01:00 14 октября (МСК), на коммуникационном оборудовании запланированы профилактические работы. В это время может наблюдаться недоступность системы GSM мониторинга и/или задержки в получении данных телеметрии от водоматов. Суммарное время перерыва составит не более 30 минут. Приносим извинения за доставленные неудобства."
msgstr "С 22:00 13 октября (МСК) по 01:00 14 октября (МСК), на коммуникационном оборудовании запланированы профилактические работы. В это время может наблюдаться недоступность системы GSM мониторинга и/или задержки в получении данных телеметрии от водоматов. Суммарное время перерыва составит не более 30 минут. Приносим извинения за доставленные неудобства."

#: src/containers/Migrations/Migrations.tsx:3210
msgid "с аппаратами"
msgstr "с аппаратами"

#: src/containers/Users/UserMenu.tsx:139
#: src/components/CartridgeValue/ResetButton.tsx:22
msgid "Сбросить"
msgstr "Сбросить"

#: src/containers/Users/UserMenu.tsx:208
msgid "Сбросить пароль"
msgstr "Сбросить пароль"

#: src/containers/Users/UserMenu.tsx:138
msgid "Сбросить пароль пользователя?"
msgstr "Сбросить пароль пользователя?"

#: src/containers/Migrations/Migrations.tsx:3432
#: src/containers/Migrations/Migrations.tsx:3636
msgid "Сбросить фильтр"
msgstr "Сбросить фильтр"

#: src/containers/Migrations/Migrations.tsx:1301
msgid "Свободен"
msgstr "Свободен"

#: src/containers/Migrations/Migrations.tsx:2777
msgid "Сервис"
msgstr "Сервис"

#: src/containers/Migrations/Migrations.tsx:1221
msgid "Синхронизация счётчиков telemetry в Redis"
msgstr "Синхронизация счётчиков telemetry в Redis"

#: src/containers/Migrations/Migrations.tsx:3506
msgid "Синхронизировать аппараты"
msgstr "Синхронизировать аппараты"

#: src/containers/Migrations/Migrations.tsx:3324
msgid "Синхронизировать пользователей"
msgstr "Синхронизировать пользователей"

#: src/containers/Migrations/Migrations.tsx:4008
msgid "Системные данные"
msgstr "Системные данные"

#: src/containers/Profile/EditProfile.tsx:92
msgid "Смена пароля"
msgstr "Смена пароля"

#: src/containers/Migrations/Migrations.tsx:3520
msgid "Сменили владельца: {reassignedDeviceCount}"
msgstr "Сменили владельца: {reassignedDeviceCount}"

#: src/containers/Terminals/Terminal/DeviceLogs/DeviceLogs.tsx:101
msgid "Событие"
msgstr "Событие"

#: src/containers/Migrations/Migrations.tsx:660
#: src/containers/Migrations/Migrations.tsx:948
#: src/containers/Migrations/Migrations.tsx:3819
msgid "События"
msgstr "События"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:328
msgid "Совпадение строк"
msgstr "Совпадение строк"

#: src/containers/Migrations/Migrations.tsx:2961
msgid "Соединения: активные / всего"
msgstr "Соединения: активные / всего"

#: src/containers/DeviceList/AuditTab/AuditTab.tsx:210
msgid "Сортировать по дате"
msgstr "Сортировать по дате"

#: src/containers/Migrations/Migrations.tsx:3781
msgid "Состав переносимых данных"
msgstr "Состав переносимых данных"

#: src/containers/Terminals/Terminal/Device.tsx:94
#: src/containers/Migrations/SystemMigrations.tsx:214
msgid "Состояние"
msgstr "Состояние"

#: src/containers/Terminals/Terminal/DeviceState/BotlerStatus.tsx:33
msgid "Состояние бутылочника"
msgstr "Состояние бутылочника"

#: src/containers/Migrations/Migrations.tsx:2644
msgid "Состояния аппаратов сравнены"
msgstr "Состояния аппаратов сравнены"

#: src/containers/Omnidesk/Omnidesk.tsx:36
msgid "Сотрудник"
msgstr "Сотрудник"

#: src/config/menu.tsx:125
msgid "Сотрудники"
msgstr "Сотрудники"

#: src/containers/Migrations/SystemMigrations.tsx:50
msgid "Сохранение в MinIO"
msgstr "Сохранение в MinIO"

#: src/containers/Migrations/Migrations.tsx:1227
msgid "Сохранение резервной копии в MinIO"
msgstr "Сохранение резервной копии в MinIO"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:109
#: src/components/DeviceRemain.tsx:48
#: src/components/LastServiceDate/LastServiceDate.tsx:170
#: src/components/EditAuditComment/EditAuditCommentModal.tsx:77
msgid "Сохранить"
msgstr "Сохранить"

#: src/features/deviceAlerts/i18n/translations.ts:16
msgid "Сработал датчик малого уровня воды в баке"
msgstr "Сработал датчик малого уровня воды в баке"

#: src/features/deviceAlerts/i18n/translations.ts:10
msgid "Сработал датчик низкого давления"
msgstr "Сработал датчик низкого давления"

#: src/features/deviceAlerts/i18n/translations.ts:11
msgid "Сработал датчик открытия двери"
msgstr "Сработал датчик открытия двери"

#: src/containers/Migrations/Migrations.tsx:2650
msgid "Сравнение аппаратов завершено с ошибками"
msgstr "Сравнение аппаратов завершено с ошибками"

#: src/containers/Migrations/DeviceStateComparisonModal.tsx:303
msgid "Сравнение состояний аппарата"
msgstr "Сравнение состояний аппарата"

#: src/containers/Migrations/Migrations.tsx:2653
msgid "Сравнено: {comparedCount}, ошибок: {failedCount}"
msgstr "Сравнено: {comparedCount}, ошибок: {failedCount}"

#: src/containers/Migrations/Migrations.tsx:2652
msgid "Сравнено: {comparedCount}, ошибок: {failedCount}. Первая ошибка: {deviceId}: {failureMessage}"
msgstr "Сравнено: {comparedCount}, ошибок: {failedCount}. Первая ошибка: {deviceId}: {failureMessage}"

#: src/containers/Migrations/Migrations.tsx:1088
msgid "Сравнить состояния аппарата"
msgstr "Сравнить состояния аппарата"

#: src/containers/Migrations/MigrationDailyChart.tsx:54
msgid "Среднее время миграции"
msgstr "Среднее время миграции"

#: src/containers/Sales/DeviceIncome.tsx:30
msgid "Средства зачислены"
msgstr "Средства зачислены"

#: src/components/ConnectBot/ConnectMaxBot.tsx:106
#: src/components/ConnectBot/ConnectMaxBot.tsx:120
#: src/components/ConnectBot/ConnectBot.tsx:108
#: src/components/ConnectBot/ConnectBot.tsx:127
msgid "Ссылка скопирована в буфер обмена"
msgstr "Ссылка скопирована в буфер обмена"

#: src/containers/UserInfo/UserInfo.tsx:91
#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:104
msgid "Статистика"
msgstr "Статистика"

#: src/containers/Dashboard/Users/Users.tsx:62
msgid "Статистика по месяцам"
msgstr "Статистика по месяцам"

#: src/locales/constants.ts:55
#: src/containers/Migrations/SystemMigrations.tsx:268
#: src/containers/Migrations/Migrations.tsx:2780
msgid "Статус"
msgstr "Статус"

#: src/containers/Migrations/Migrations.tsx:644
#: src/containers/Migrations/Migrations.tsx:915
msgid "Статус миграции"
msgstr "Статус миграции"

#: src/containers/Migrations/Migrations.tsx:2566
#: src/containers/Migrations/Migrations.tsx:2571
msgid "Статус миграции изменён: {updatedCount}"
msgstr "Статус миграции изменён: {updatedCount}"

#: src/containers/Migrations/SystemMigrations.tsx:134
msgid "Статус недоступен; данные могут быть устаревшими"
msgstr "Статус недоступен; данные могут быть устаревшими"

#: src/containers/Migrations/Migrations.tsx:639
#: src/containers/Migrations/Migrations.tsx:904
#: src/containers/Migrations/Migrations.tsx:2787
msgid "Статус оценки"
msgstr "Статус оценки"

#: src/features/uvLampStatus/components/UVLampStatusSwitch.tsx:7
msgid "Статус УФ лампы"
msgstr "Статус УФ лампы"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:42
msgid "Статус шторки"
msgstr "Статус шторки"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:125
msgid "Статусы worker pod'ов"
msgstr "Статусы worker pod'ов"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:58
msgid "Стоимость литра"
msgstr "Стоимость литра"

#: src/containers/UserGroups/useUserGroupColumns.tsx:35
msgid "Страна"
msgstr "Страна"

#: src/containers/Dashboard/Geography/Geography.tsx:24
msgid "Страны"
msgstr "Страны"

#: src/containers/DeviceList/columns/filtersColumns.tsx:23
msgid "Ступени очистки <0/>"
msgstr "Ступени очистки <0/>"

#: src/containers/Services/BalanceHistory.tsx:32
msgid "Сумма"
msgstr "Сумма"

#: src/containers/Services/Recharge.tsx:167
msgid "Сумма в рублях"
msgstr "Сумма в рублях"

#. placeholder {0}: formatMoney(data.income, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:244
msgid "Суммарная выручка = {0}"
msgstr "Суммарная выручка = {0}"

#: src/features/salesDynamics/ui/SalesDynamicsTotal.tsx:40
msgid "Суммарная динамика продаж"
msgstr "Суммарная динамика продаж"

#. placeholder {0}: formatMoney(data.profit, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:245
msgid "Суммарная прибыль = {0}"
msgstr "Суммарная прибыль = {0}"

#. placeholder {0}: formatMoney(data.expenses, currency)
#: src/containers/OraclePage/ComputeTab/utils.ts:242
msgid "Суммарные операционные расходы = {0}"
msgstr "Суммарные операционные расходы = {0}"

#: src/containers/Migrations/Migrations.tsx:634
msgid "Схожесть"
msgstr "Схожесть"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:20
msgid "Счетчик ХВС"
msgstr "Счетчик ХВС"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:19
msgid "Счетчик Электроэнергии"
msgstr "Счетчик Электроэнергии"

#: src/containers/Migrations/Migrations.tsx:3098
msgid "Текущая таблица"
msgstr "Текущая таблица"

#: src/containers/Migrations/Migrations.tsx:2866
msgid "Текущее потребление"
msgstr "Текущее потребление"

#: src/containers/Migrations/Migrations.tsx:3020
msgid "Текущий лимит"
msgstr "Текущий лимит"

#: src/newComponents/Faq/Faq.tsx:55
msgid "Телеграмм чат технической поддержки <0>@alivewaternewbot</0>"
msgstr "Телеграмм чат технической поддержки <0>@alivewaternewbot</0>"

#: src/containers/Migrations/Migrations.tsx:3933
msgid "Телеметрии"
msgstr "Телеметрии"

#: src/containers/Migrations/Migrations.tsx:3820
#: src/containers/Migrations/Migrations.tsx:3906
msgid "Телеметрия"
msgstr "Телеметрия"

#: src/containers/Migrations/Migrations.tsx:3814
msgid "Телеметрия ÷ 10"
msgstr "Телеметрия ÷ 10"

#: src/containers/Migrations/Migrations.tsx:3813
msgid "Телеметрия ÷ 5"
msgstr "Телеметрия ÷ 5"

#: src/locales/constants.ts:53
msgid "Телефон"
msgstr "Телефон"

#: src/locales/constants.ts:18
msgid "Телефон поддержки"
msgstr "Телефон поддержки"

#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:21
#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:33
msgid "Температура включения больше или равна температуре выключения"
msgstr "Температура включения больше или равна температуре выключения"

#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:27
#: src/containers/Terminals/EditDevice/MainboardFields/MainboardFields.tsx:39
msgid "Температура выключения меньше или равна температуре включения"
msgstr "Температура выключения меньше или равна температуре включения"

#. placeholder {0}: data.address
#: src/containers/OraclePage/ComputeTab/utils.ts:212
msgid "Терминал по адресу {0}"
msgstr "Терминал по адресу {0}"

#: src/containers/Main/Main.tsx:79
msgid "Техническая поддержка<0/>с 07: 00 до 21: 00 МСК"
msgstr "Техническая поддержка<0/>с 07: 00 до 21: 00 МСК"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:98
#: src/config/menu.tsx:131
msgid "Технические работы"
msgstr "Технические работы"

#: src/containers/SystemMaintenance/SystemMaintenance.tsx:106
msgid "Технические работы (aka \"шторка\")"
msgstr "Технические работы (aka \"шторка\")"

#: src/components/Stats/constants.ts:19
msgid "Тип воды"
msgstr "Тип воды"

#: src/containers/Migrations/SystemMigrations.tsx:263
msgid "Тип миграции"
msgstr "Тип миграции"

#: src/containers/Migrations/Migrations.tsx:3893
msgid "Топ-20 пользователей"
msgstr "Топ-20 пользователей"

#: src/locales/constants.ts:6
msgid "Точный адрес установки аппарата"
msgstr "Точный адрес установки аппарата"

#: src/containers/Migrations/Migrations.tsx:2906
msgid "Транзакции"
msgstr "Транзакции"

#: src/containers/StoreOrders/StoreOrders.tsx:107
msgid "Транспортная компания"
msgstr "Транспортная компания"

#: src/components/Stats/TrendsLegend.tsx:22
msgid "Тренд"
msgstr "Тренд"

#: src/containers/StoreOrders/StoreOrders.tsx:63
msgid "У вас нет заказов за последний месяц."
msgstr "У вас нет заказов за последний месяц."

#: src/features/serviceNotification/ServiceNotification.tsx:21
msgid "Уведомление о проведении сервисных работ"
msgstr "Уведомление о проведении сервисных работ"

#: src/containers/Migrations/Migrations.tsx:1233
msgid "Удаление временных файлов"
msgstr "Удаление временных файлов"

#: src/containers/Migrations/Migrations.tsx:3521
msgid "Удалено аппаратов: {removedDeviceCount}"
msgstr "Удалено аппаратов: {removedDeviceCount}"

#: src/containers/Users/UserMenu.tsx:115
#: src/containers/Terminals/Terminal/TerminalTitle.tsx:88
#: src/containers/Staff/StaffForm.tsx:87
msgid "Удалить"
msgstr "Удалить"

#: src/containers/Terminals/Terminal/TerminalTitle.tsx:87
msgid "Удалить аппарат?"
msgstr "Удалить аппарат?"

#: src/containers/Users/UserMenu.tsx:218
msgid "Удалить пользователя"
msgstr "Удалить пользователя"

#: src/containers/Users/UserMenu.tsx:114
msgid "Удалить пользователя?"
msgstr "Удалить пользователя?"

#: src/containers/Migrations/SystemMigrations.tsx:254
#: src/containers/Migrations/Migrations.tsx:3445
msgid "Удобный формат времени"
msgstr "Удобный формат времени"

#: src/containers/Migrations/Migrations.tsx:2179
msgid "Уже выполняется миграция другого пользователя"
msgstr "Уже выполняется миграция другого пользователя"

#: src/containers/Migrations/Migrations.tsx:2100
msgid "Уже выполняется оценка другого пользователя. Дождитесь её завершения."
msgstr "Уже выполняется оценка другого пользователя. Дождитесь её завершения."

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:117
msgid "УЗ датчик"
msgstr "УЗ датчик"

#. placeholder {0}: formatMoney(price * MAX_INCOME_LIMIT, currency)
#: src/containers/Sales/DeviceIncome.tsx:96
msgid "Укажите сумму для пополнения баланса на выбранном аппарате для покупки воды. Максимальная сумма пополнения - {0}"
msgstr "Укажите сумму для пополнения баланса на выбранном аппарате для покупки воды. Максимальная сумма пополнения - {0}"

#: src/containers/Migrations/Migrations.tsx:3115
msgid "Управление процессами"
msgstr "Управление процессами"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:101
msgid "Уровень сигнала"
msgstr "Уровень сигнала"

#: src/containers/Dashboard/BillingStats/columns.tsx:38
#: src/containers/Dashboard/BillingStats/BillingLogs.tsx:15
msgid "Услуга"
msgstr "Услуга"

#: src/config/menu.tsx:73
msgid "Услуги"
msgstr "Услуги"

#: src/containers/Dashboard/BillingStats/columns.tsx:63
msgid "Успешно обработано"
msgstr "Успешно обработано"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:53
msgid "Устройство включено"
msgstr "Устройство включено"

#: src/containers/Terminals/Terminal/Device.tsx:84
msgid "Устройство заблокировано из-за не хватки средств"
msgstr "Устройство заблокировано из-за не хватки средств"

#: src/containers/Terminals/Terminal/DeviceState/TerminalSummary.tsx:57
#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:65
msgid "Устройство обновлено"
msgstr "Устройство обновлено"

#: src/containers/Migrations/Migrations.tsx:2828
msgid "Утилизация CPU pod"
msgstr "Утилизация CPU pod"

#: src/containers/DeviceList/columns/desktop.tsx:102
msgid "УФ лампа"
msgstr "УФ лампа"

#: src/locales/constants.ts:47
msgid "Фамилия"
msgstr "Фамилия"

#: src/containers/Migrations/Migrations.tsx:2947
msgid "Физическая запись"
msgstr "Физическая запись"

#: src/containers/Migrations/Migrations.tsx:2939
msgid "Физическое чтение"
msgstr "Физическое чтение"

#: src/containers/Migrations/Migrations.tsx:3627
msgid "Фильтр по выбранным пользователям не установлен"
msgstr "Фильтр по выбранным пользователям не установлен"

#: src/containers/Migrations/Migrations.tsx:3626
msgid "Фильтр по выбранным пользователям: {deviceOwnerFilterCount}"
msgstr "Фильтр по выбранным пользователям: {deviceOwnerFilterCount}"

#: src/containers/DeviceList/constants.ts:24
msgid "Фильтры"
msgstr "Фильтры"

#: src/containers/Migrations/Migrations.tsx:3589
msgid "Фин. настройки Oracle"
msgstr "Фин. настройки Oracle"

#: src/containers/Migrations/Migrations.tsx:2604
msgid "Финансовые настройки Oracle"
msgstr "Финансовые настройки Oracle"

#: src/containers/Terminals/Terminal/DeviceState/DeviceState.tsx:54
msgid "Финансы"
msgstr "Финансы"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:104
msgid "Финансы - поступления"
msgstr "Финансы - поступления"

#: src/containers/Dashboard/AllMoney/AllMoney.tsx:112
msgid "Финансы - списания"
msgstr "Финансы - списания"

#: src/containers/Terminals/Terminal/Device.tsx:117
#: src/containers/Terminals/EditDevice/EditDeviceTabTitle.tsx:25
msgid "Фискализация"
msgstr "Фискализация"

#: src/containers/Migrations/Migrations.tsx:2602
#: src/containers/Migrations/Migrations.tsx:3573
msgid "Фискальные настройки"
msgstr "Фискальные настройки"

#: src/containers/Migrations/Migrations.tsx:2872
msgid "Целевая нагрузка"
msgstr "Целевая нагрузка"

#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:79
msgid "Цена 1 литра по банковской карте"
msgstr "Цена 1 литра по банковской карте"

#: src/containers/Terminals/EditDevice/MainboardFields/BottlerFields.tsx:16
msgid "Цена бутылки, {currencySign}"
msgstr "Цена бутылки, {currencySign}"

#: src/locales/constants.ts:8
#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:67
msgid "Цена за литр"
msgstr "Цена за литр"

#: src/locales/constants.ts:10
#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:86
msgid "Цена за литр минеральной воды"
msgstr "Цена за литр минеральной воды"

#: src/locales/constants.ts:9
#: src/containers/Terminals/Terminal/DeviceState/TerminalFinState.tsx:72
msgid "Цена за литр по IC карте"
msgstr "Цена за литр по IC карте"

#: src/locales/constants.ts:27
#: src/containers/Migrations/formatDuration.tsx:18
msgid "ч"
msgstr "ч"

#: src/components/Stats/constants.ts:10
msgid "Час"
msgstr "Час"

#: src/locales/constants.ts:13
msgid "Часовой пояс"
msgstr "Часовой пояс"

#: src/containers/Omnidesk/OmniChat.tsx:44
msgid "Чат"
msgstr "Чат"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:102
msgid "четырехстрочный"
msgstr "четырехстрочный"

#: src/containers/Terminals/EditDevice/MainboardFields/options.ts:106
msgid "четырехстрочный с десятыми долями баланса"
msgstr "четырехстрочный с десятыми долями баланса"

#: src/containers/Migrations/Migrations.tsx:2913
msgid "Чтение строк"
msgstr "Чтение строк"

#: src/containers/Terminals/Terminal/DeviceState/MeterValue.tsx:70
#: src/components/EditAuditComment/EditAuditCommentModal.tsx:60
#: src/components/ConnectBot/ConnectMaxBot.tsx:174
#: src/components/ConnectBot/ConnectBot.tsx:184
#: src/components/CartridgeValue/EditValueModal.tsx:96
msgid "Что-то пошло не так"
msgstr "Что-то пошло не так"

#: src/locales/constants.ts:21
msgid "Широта"
msgstr "Широта"

#: src/config/menu.tsx:94
#: src/config/menu.tsx:100
msgid "Школа вендора"
msgstr "Школа вендора"

#: src/components/LastServiceDate/LastServiceDate.tsx:149
msgid "Это действие изменит дату обслуживания для ВСХ аппаратов в вашем личном кабинете! Вы уверены?"
msgstr "Это действие изменит дату обслуживания для ВСХ аппаратов в вашем личном кабинете! Вы уверены?"

#: src/components/CartridgeValue/EditValueModal.tsx:154
msgid "Я поменял счётчик ХВС"
msgstr "Я поменял счётчик ХВС"
